const en: Record<string, string> = {
  'nav.overview': 'Overview',
  'nav.bookings': 'My Bookings',
  'nav.favorites': 'Favorite Companies',
  'nav.home': 'Home',
  'nav.dashboard': 'Dashboard',
  'nav.tracker': 'Tracker',
  'nav.profile': 'Profile',
  'nav.sign_in': 'Sign In',
  'nav.join_company': 'Join as Company',
  'nav.notifications': 'Notifications',
  'nav.mark_all_read': 'Mark all read',
  'nav.open': 'Open',
  'nav.delete': 'Delete',
  'nav.customer': 'Customer',
  'nav.company': 'Company',
  'nav.sign_out': 'Sign out',
  'brand.name': 'Halomora',
  'dash.welcome': 'Welcome back!',
  'dash.subtitle': 'Track your service bookings and manage your account',
  'dash.range.1m': '1 Month',
  'dash.range.3m': '3 Months',
  'dash.range.6m': '6 Months',
  'dash.range.1y': '1 Year',
  'dash.spending_trend': 'Monthly Spending Trend',
  'dash.service_breakdown': 'Service Category Breakdown',
  'dash.service_breakdown.empty': 'No data available for the selected period',
  'dash.recent_history': 'Recent Service History',
  'dash.favorite_companies': 'Your Favorite Companies',
  'booking.step.schedule': 'Choose Your Schedule',
  'booking.step.details': 'Service Details & Preferences',
  'booking.step.info': 'Your Information',
  'booking.step.review': 'Review & Confirm',
  'booking.btn.next': 'Next Step',
  'booking.btn.prev': 'Previous',
  'booking.btn.confirm': 'Confirm Booking',
  'booking.service_type': 'Service Type',
  'booking.property_size': 'Property Size',
  'booking.urgency': 'Urgency Level',
  'booking.special_instructions': 'Special Instructions',
  'booking.upload_photos': 'Upload Photos (Optional)',
  'booking.request_quote': "Can't find what you need? Request a quote",
  'booking.summary': 'Booking Summary',
  'profile.title': 'My Profile',
  'profile.tab.bookings': 'Bookings',
  'profile.tab.personal': 'Personal',
  'profile.tab.addresses': 'Addresses',
  'profile.tab.payments': 'Payments',
  'profile.tab.notifications': 'Communications',
  'profile.tab.loyalty': 'Benefits',
  'profile.tab.security': 'Security',
  'profile.tab.quotes': 'Quotes',
  'vendor.tabs.bookings': 'Recent Bookings',
  'vendor.tabs.calendar': 'Calendar View',
  'vendor.tabs.tracker': 'Booking Tracker',
  'vendor.tracker.no_company': 'Company profile not available.',
  'vendor.tabs.quotes': 'Quote Requests',
  'vendor.tabs.services': 'Service Builder',
  'vendor.tabs.pricing': 'Smart Pricing',
  'vendor.tabs.analytics': 'Analytics',
  'vendor.google.title': 'Connect Google Calendar',
  'vendor.google.desc': 'Keep your bookings in sync with your Google Calendar. Connect your account in seconds.',
  'vendor.google.connect': 'Connect Google Calendar',
  'payments.success.title': 'Booking Confirmed!',
  'payments.success.subtitle': 'Your service has been successfully booked and payment processed.',
  'payments.order.confirmation': 'Order Confirmation',
  'payments.field.date': 'Date',
  'payments.field.time': 'Time',
  'payments.field.address': 'Service Address',
  'payments.contact.info': 'Contact Information',
  'payments.btn.add_calendar': 'Add to Calendar',
  'payments.btn.download_receipt': 'Download Receipt',
  'payments.btn.my_orders': 'My Bookings',
  'company.back_to_search': 'Back to Search',
  'company.services_pricing': 'Services & Pricing',
  'company.faq_details': 'FAQ & Details',
  'company.whats_included': "What's included?",
  'company.why_choose': 'Why choose this company',
  'company.select_service': 'Select Service',
  'company.recent_reviews': 'Recent Reviews',
  'company.member_since': 'Member since',
  'vendor.quotes.title': 'Quote Request Manager',
  'vendor.quotes.desc': 'Manage customer quote requests and respond with competitive pricing',
  'vendor.quotes.tabs.all': 'All',
  'vendor.quotes.tabs.pending': 'Pending',
  'vendor.quotes.tabs.quoted': 'Quoted',
  'vendor.quotes.tabs.accepted': 'Accepted',
  'vendor.quotes.no_requests_title': 'No quote requests',
  'vendor.quotes.no_requests_all': "You haven't received any quote requests yet.",
  'vendor.quotes.no_requests_filter': 'No {{status}} quote requests at the moment.',
  'vendor.quotes.special_requests': 'Special Requests:',
  'vendor.quotes.your_quote': 'Your Quote:',
  'vendor.quotes.photos': 'Photos ({{count}})',
  'vendor.quotes.photo_label': 'Photo {{index}}',
  'vendor.quotes.send': 'Send Quote',
  'vendor.quotes.send_to': 'Send Quote to {{name}}',
  'vendor.quotes.send_desc': 'Provide your pricing and message for this request',
  'vendor.quotes.form.price': 'Price ($)',
  'vendor.quotes.form.duration': 'Estimated Duration (minutes)',
  'vendor.quotes.form.message': 'Message',
  'vendor.quotes.form.message_placeholder': 'Explain your approach, experience, and any special considerations...',
  'vendor.quotes.btn.accept': 'Accept',
  'vendor.quotes.btn.reject': 'Reject',
  'vendor.quotes.toast.sent_title': 'Quote Sent',
  'vendor.quotes.toast.sent_desc': 'Quote of ${{price}} sent.',
  'vendor.quotes.toast.status_updated': 'Status Updated',
  'vendor.quotes.toast.status_changed': 'Quote request status changed to {{status}}',
  'common.error': 'Error',
  'calendar.title': 'Interactive Calendar',
  'calendar.desc': 'View and manage your bookings. Click on a booking to see details and update status.',
  'calendar.badge.bookings': 'bookings',
  'calendar.empty': 'No bookings for this date',
  'calendar.today': 'Today',
  'calendar.tomorrow': 'Tomorrow',
  'calendar.details.title': 'Booking Details',
  'calendar.details.desc': 'Manage booking status and view customer information',
  'calendar.customer_info': 'Customer Information',
  'calendar.service_details': 'Service Details',
  'calendar.field.service': 'Service:',
  'calendar.field.amount': 'Amount:',
  'calendar.field.notes': 'Notes:',
  'calendar.status_mgmt': 'Status Management',
  'calendar.current_status': 'Current Status:',
  'calendar.update_status': 'Update Status:',
  'calendar.status.pending': 'Pending',
  'calendar.status.confirmed': 'Confirmed',
  'calendar.status.in_progress': 'In Progress',
  'calendar.status.completed': 'Completed',
  'calendar.status.cancelled': 'Cancelled',
  'calendar.reschedule.title': 'Reschedule',
  'calendar.reschedule.new_date': 'New Date',
  'calendar.reschedule.start_time': 'Start Time',
  'calendar.reschedule.helper': 'Use the start time (e.g., 08:00)',
  'calendar.reschedule.save': 'Save Reschedule',
  'calendar.quick_actions.title': 'Quick Actions',
  'calendar.quick_actions.call': 'Call',
  'calendar.quick_actions.email': 'Email',
  'calendar.quick_msgs.on_way': "We're on the way",
  'calendar.quick_msgs.late': 'Running 10 minutes late',
  'calendar.quick_msgs.access': 'Any access instructions?',
  'calendar.quick_msgs.parking': 'Please confirm parking location',
  'calendar.quick_msgs.placeholder': 'Type a custom message...',
  'calendar.quick_msgs.copy_send': 'Send',
  'calendar.quick_msgs.send_email': 'Send via Email',
  'calendar.toast.status_updated': 'Status Updated',
  'calendar.toast.status_changed': 'Booking status changed to {{status}}',
  'calendar.toast.rescheduled': 'Booking moved to {{date}}',
  'calendar.toast.missing_fields': 'Pick a date and time',
  'onboard.services.title': 'Services & Pricing',
  'onboard.services.desc': 'Add the services you offer to help customers understand what you provide',
  'onboard.services.name': 'Service Name',
  'onboard.services.category': 'Category',
  'onboard.services.select_category': 'Select a category',
  'onboard.services.description': 'Description',
  'onboard.services.types_title': 'Service Types (Cleaning only)',
  'onboard.services.types_helper': 'Confirm which types you offer. Only selected types will be shown to customers.',
  'onboard.services.tags_title': 'Tags (synonyms & keywords)',
  'onboard.services.tags_placeholder': 'Add a tag and press Enter (e.g., pulizie, cleaning, vetri)',
  'onboard.services.pricing_type': 'Pricing Type',
  'onboard.services.pricing.fixed': 'Fixed Price',
  'onboard.services.pricing.hourly': 'Per Hour',
  'onboard.services.pricing.per_sqm': 'Per Square Meter',
  'onboard.services.pricing.custom': 'Custom',
  'onboard.services.base_price': 'Base Price ($)',
  'onboard.services.duration': 'Duration (minutes)',
  'onboard.services.vendor_covers_fee.title': 'Vendor covers customer fee',
  'onboard.services.vendor_covers_fee.desc': 'If enabled, the customer fee is covered by the vendor (price shown may reflect this).',
  'onboard.services.show_fee_disclaimer.title': 'Show fee disclaimer to customers',
  'onboard.services.show_fee_disclaimer.desc': 'Show a disclaimer in the summary: "Customer fees are covered by the vendor."',
  'onboard.services.add_service': 'Add Service',
  'onboard.services.added_services': 'Added Services ({{count}})',
  'onboard.services.remove': 'Remove',
  'onboard.services.continue_availability': 'Continue to Availability',
  'onboard.welcome.subtitle': "Let's set up your company profile in just a few steps",
  'onboard.company.title': 'Company Information',
  'onboard.company.desc': 'Tell us about your company to help customers find and trust your services',
  'onboard.company.name': 'Company Name',
  'onboard.company.email': 'Email',
  'onboard.company.primary_categories': 'Primary Categories',
  'onboard.company.service_areas': 'Service Areas (Cities or ZIPs)',
  'onboard.company.service_areas_ph': 'Add city or ZIP and press Enter',
  'onboard.company.service_areas_desc': 'Add all cities where you provide services. More areas = more customers can find you!',
  'onboard.company.service_areas_suggestions': 'Popular areas near you:',
  'onboard.company.coverage_level': 'Coverage Level:',
  'onboard.company.coverage_national': 'National',
  'onboard.company.coverage_regional': 'Regional',
  'onboard.company.coverage_local': 'Local',
  'onboard.company.coverage_national_desc': 'Great! You serve customers across Italy.',
  'onboard.company.coverage_regional_desc': 'Good regional coverage. Consider adding more areas.',
  'onboard.company.coverage_local_desc': 'Add more cities to reach more customers.',
  'onboard.company.description': 'Description',
  'onboard.company.description_ph': 'Tell customers about your company and what makes you special...',
  'onboard.company.address': 'Address',
  'onboard.company.city': 'City',
  'onboard.company.postal_code': 'Postal Code',
  'onboard.company.phone': 'Phone',
  'onboard.company.tax_id': 'Tax ID (Optional)',
  'onboard.company.website': 'Website (Optional)',
  'onboard.actions.continue_services': 'Continue to Services',
  'onboard.availability.title': 'Set Your Availability',
  'onboard.availability.desc': 'Configure your working hours to help customers book services at convenient times',
  'onboard.availability.to': 'to',
  'onboard.actions.continue_review': 'Continue to Review',
  'onboard.review.title': 'Review & Complete',
  'onboard.review.desc': 'Review your information before completing the onboarding process',
  'onboard.review.company_info': 'Company Information',
  'onboard.review.services': 'Services ({{count}})',
  'onboard.review.availability': 'Availability',
  'onboard.availability.not_available': 'Not available',
  'onboard.actions.complete': 'Complete Onboarding',
  'vendor.share_public': 'Share Public Link',
  'vendor.toast.link_copied': 'Link copied',
  'vendor.toast.link_desc': 'Public booking link copied to clipboard.',
  'auth.title.create': 'Create Account',
  'auth.title.welcome': 'Welcome Back',
  'auth.subtitle.signup': 'Join Halomora to start your journey',
  'auth.subtitle.signin': 'Sign in to your account to continue',
  'auth.btn.loading': 'Loading...',
  'auth.btn.create': 'Create Account',
  'auth.btn.create_company': 'Create Company Account',
  'auth.btn.signin': 'Sign In',

  'auth.seo.title': 'Sign in or register | Halomora',
  'auth.back': 'Back',
  'auth.badge': 'Platform access',
  'auth.panel.title': 'Sign in with a clearer path from the first step.',
  'auth.panel.subtitle': 'Halomora guides customers and companies with clearer, reliable sign-in. Choose your profile and continue with the flow that fits your case.',
  'auth.panel.setup.title': 'Guided setup',
  'auth.panel.setup.desc': 'Separate paths for customer and company, with progressive onboarding that is easier to follow.',
  'auth.panel.trust.title': 'Immediate trust',
  'auth.panel.trust.desc': 'Sign-in, email verification and policies explained in a more understandable way.',
  'auth.panel.convert.title': 'Ready to convert',
  'auth.panel.convert.desc': 'As a company you start with your profile then complete onboarding; as a customer you enter the workspace right away.',
  'auth.panel.stat.paths': 'distinct paths',
  'auth.panel.stat.access': 'central access',
  'auth.panel.stat.friction': 'visual friction',
  'auth.brand_badge': 'Halomora access',
  'auth.tabs.customer': 'Customer',
  'auth.tabs.company': 'Company',
  'auth.path.customer.title': 'Customer path',
  'auth.path.customer.desc': 'Sign in quickly to your dashboard, bookings and support flows.',
  'auth.path.company.title': 'Company path',
  'auth.path.company.desc': 'After sign-in you continue with company onboarding: profile data, services, pricing and availability.',
  'auth.form.full_name': 'Full name',
  'auth.form.company_name': 'Company name or legal name',
  'auth.form.company_hint': 'This starts your company profile and will be reused in the next onboarding step.',
  'auth.form.email': 'Email',
  'auth.form.password': 'Password',
  'auth.terms.prefix': 'I have read the',
  'auth.terms.link': 'Terms of Service',
  'auth.privacy.prefix': 'I have read the',
  'auth.privacy.link': 'Privacy Policy',
  'auth.btn.google': 'Continue with Google',
  'auth.switch.signin': 'Already have an account? Sign in',
  'auth.switch.signup': 'Don\'t have an account? Sign up',
  'auth.resend.sending': 'Sending...',
  'auth.resend.text': 'Resend verification email',
  'auth.validation.email': 'Please enter a valid email',
  'auth.validation.password': 'Password must be at least 6 characters',
  'auth.toast.email_required': 'Please enter your email address first.',
  'auth.toast.error': 'Error',
  'auth.toast.verification_sent_title': 'Verification email sent!',
  'auth.toast.verification_sent_desc': 'Please check your email and click the verification link.',
  'auth.toast.resend_rate_limit_title': 'Too many attempts',
  'auth.toast.resend_rate_limit_desc': 'You requested too many emails in a short time. Please try again in a few minutes.',
  'auth.toast.resend_failed': 'Failed to resend verification email.',
  'auth.toast.full_name_required': 'Full name is required for sign up.',
  'auth.toast.accept_legal_title': 'Please accept the Terms and Privacy Policy',
  'auth.toast.accept_legal_desc': 'You must accept both to create an account.',
  'auth.toast.email_verified_title': 'Email verified!',
  'auth.toast.email_verified_desc': 'Your email has been verified. You can now sign in.',
  'auth.toast.account_created_title': 'Account created successfully!',
  'auth.toast.welcome': 'Welcome to Halomora!',
  'auth.toast.check_email': 'Please check your email and click the verification link to continue.',
  'auth.toast.email_not_verified_title': 'Email not verified',
  'auth.toast.email_not_verified_desc': 'Please check your email and click the verification link before signing in.',
  'auth.toast.profile_create_failed': 'Failed to create user profile. Please contact support.',
  'auth.toast.welcome_back_title': 'Welcome back!',
  'auth.toast.welcome_back_desc': 'You have been successfully signed in.',
  'auth.toast.profile_load_failed': 'Failed to load user profile. Please try again.',
  'auth.toast.signup_rate_limit_title': 'Too many attempts',
  'auth.toast.signup_rate_limit_desc': 'To prevent abuse, email sending is temporarily limited. Wait a few minutes and try again.',
  'auth.toast.unexpected_error': 'An unexpected error occurred. Please try again.',
  'auth.toast.google_failed_title': 'Google sign-in failed',
  'auth.toast.validation_title': 'Validation Error',
  'auth.toast.validation_desc': 'Please check your input and try again.',
  'booking.next': 'Next Step',
  'booking.previous': 'Previous',
  'booking.confirm': 'Confirm Booking',
  'header.switch_language': 'Language',

  // Header toasts & extras
  'header.toast.signed_out_title': 'Signed out',
  'header.toast.signed_out_desc': 'You have been successfully signed out.',
  'nav.no_notifications': 'No notifications',
  'nav.support': 'Support',
  'nav.mark_read': 'Mark as read',
  'nav.booking_ref': 'Booking',
  'nav.sign_in_short': 'Sign In',
  'nav.join_company_short': 'Company',

  // Footer
  'footer.rights': '© {{year}} Halomora. All rights reserved.',
  'footer.for_businesses': 'For Businesses',
  'footer.apartment_manager': 'Apartment Manager',
  'footer.status': 'Status',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.cookies': 'Cookies',
  'footer.imprint': 'Imprint',
  'footer.subprocessors': 'Subprocessors',
  'footer.faq': 'FAQ',
  'footer.cookie_preferences': 'Cookie Preferences',

  // 404 / NotFound
  'notfound.seo_title': 'Page Not Found | Halomora',
  'notfound.heading': '404',
  'notfound.message': 'Oops! Page not found',
  'notfound.back_home': 'Return to Home',

  // Status page
  'status.seo_title': 'Status | Halomora',
  'status.seo_desc': 'Halomora system & service status.',
  'status.heading': 'System Status',
  'status.env_label': 'Env',
  'status.build_time': 'Build time',
  'status.badge.ok': 'ok',
  'status.badge.degraded': 'degraded',
  'status.badge.down': 'down',
  'status.badge.unknown': 'unknown',

  // Home page
  'home.seo.title': 'Halomora | Book cleaning and maintenance services near you',
  'home.seo.description': 'Find and book home and business services: cleaning, maintenance, laundry, gardening and more. Verified companies, transparent pricing, real reviews.',
  'home.seo.results_title': 'Find a service near you | Halomora',
  'home.seo.results_description': 'Search verified companies and book services in a few clicks. Filter by city and category.',
  'home.results.back_to_search': '← Back to Search',
  'home.results.loading': 'Loading results…',
  'home.hero.title': 'Everything for your home',
  'home.hero.subtitle': 'All the services you need in one place — cleaning, maintenance, laundry, gardening, repairs and more. Book trusted professionals for your home or business in minutes.',
  'home.hero.cta_start': "Let's get started!",
  'home.hero.cta_business': 'For businesses',
  'home.trust.professionals': 'Trusted professionals',
  'home.trust.rating': 'Customer rating',
  'home.trust.rating_reviews': 'from {{count}}+ reviews',
  'home.trust.same_day': 'Same-day booking',
  'home.search.title': 'Find and book in seconds',
  'home.search.subtitle': 'Curated professionals, clear pricing and immediate availability near you.',
  'home.search.service_placeholder': 'Select a service',
  'home.search.service.home_cleaning': 'Home cleaning',
  'home.search.service.office_cleaning': 'Office cleaning',
  'home.search.service.gardening': 'Gardening',
  'home.search.service.maintenance': 'Maintenance',
  'home.search.service.laundry': 'Laundry',
  'home.search.service.disposal': 'Bulky waste disposal',
  'home.search.service.pest_control': 'Pest control',
  'home.search.city_placeholder': 'City / area',
  'home.search.when_placeholder': 'When',
  'home.search.when.today': 'Today',
  'home.search.when.tomorrow': 'Tomorrow',
  'home.search.when.this_week': 'This week',
  'home.search.note': 'You can also pick the time later during booking.',
  'home.search.cta': 'Search',
  'home.search.bulk_tooltip': 'For apartment managers: upload up to 30 orders at once (checkout/check-in).',
  'home.local.title': 'Popular services in your area',
  'home.local.subtitle': 'Find verified professionals near you',
  'home.local.companies_in': 'companies in {{city}}',
  'home.apartment_mgr.eyebrow': 'For apartment managers',
  'home.apartment_mgr.title': 'Still missing a continuous cleaning partner for the season?',
  'home.apartment_mgr.desc': "If you are already struggling to find reliable coverage in tourist areas, Halomora can help you build a long-term relationship with reputable companies and connect it to in-app operational flows.",
  'home.apartment_mgr.cta_discover': 'Discover the service',
  'home.apartment_mgr.cta_bulk': 'Go to Bulk Order',
  'home.featured.title': 'Featured services from our most active partners',
  'home.featured.subtitle': 'A selection of popular, reliable services: clear pricing, availability and one-click booking.',
  'home.featured.pro_pitch': 'Are you a service company? Get more visibility and featured placement with PRO.',
  'home.featured.cta_pro': 'Become PRO',
  'home.featured.cta_plans': 'Explore plans',
  'home.testimonials.title': 'What our customers say',
  'home.testimonials.subtitle': 'Real reviews from customers who booked on Halomora',
  'home.testimonials.verified_client': 'Verified customer',
  'home.features.title': 'Why businesses love Halomora',
  'home.features.subtitle': 'Enjoy a smooth booking experience, work with trusted professionals and get guaranteed quality for all your business cleaning needs.',
  'home.features.ai.title': 'AI-powered matching',
  'home.features.ai.desc': 'Smart recommendations based on your needs',
  'home.features.verified.title': 'Verified professionals',
  'home.features.verified.desc': 'Every company is vetted',
  'home.features.fast.title': 'Fast booking',
  'home.features.fast.desc': 'Book services in under 2 minutes',
  'home.features.quality.title': 'Guaranteed quality',
  'home.features.quality.desc': 'Only professionals with high ratings',
  'home.provider.title': 'Are you a service provider?',
  'home.provider.subtitle': 'Join our platform to grow your business with smart tools and reliable customers.',
  'home.provider.dashboard.title': 'Smart dashboard',
  'home.provider.dashboard.desc': 'Manage bookings, track earnings and grow your business with our smart dashboard.',
  'home.provider.pricing.title': 'AI-powered pricing',
  'home.provider.pricing.desc': 'Optimize your pricing with AI-powered insights and market analytics.',
  'home.provider.scheduling.title': 'Easy scheduling',
  'home.provider.scheduling.desc': 'Streamlined calendar management and automatic booking confirmations.',
  'home.provider.cta': 'Start growing your business',
  'home.faq.title': 'Frequently Asked Questions',
  'home.faq.subtitle': 'Everything you want to know about our services',
  'home.faq.cat.types': 'Service types',
  'home.faq.cat.pricing': 'Pricing & quotes',
  'home.faq.cat.booking': 'Booking & scheduling',
  'home.faq.cat.quality': 'Quality & materials',
  'home.faq.cat.general': 'General',
  'home.faq.q.types_diff_q': "What is the difference between turnover cleaning and deep cleaning?",
  'home.faq.q.types_diff_a': 'Turnover cleaning is designed for guest/tenant changeover: fast and effective, focused on hygiene and tidiness. Deep cleaning is a more thorough one-off service, recommended after long periods of disuse or when a full restoration of the spaces is needed, including corners and areas normally skipped by regular cleaning.',
  'home.faq.q.refresh_q': 'When is the refresh & inspection service useful?',
  'home.faq.q.refresh_a': 'A refresh is ideal as a quality check between cleanings. It includes tidying, removing surface dust and a general inspection of cleanliness, to maintain a consistently presentable space.',
  'home.faq.q.extra_q': 'What does the extraordinary cleaning service include?',
  'home.faq.q.extra_a': 'Extraordinary cleaning is tailored to specific needs: post-construction, after moves, special floor treatments and sanitization. We use professional machinery and specific products to ensure superior results.',
  'home.faq.q.price_calc_q': 'How are prices calculated?',
  'home.faq.q.price_calc_a': 'Prices depend on the service type (refresh, turnover, deep or extraordinary), the size of the apartment and the initial condition of the spaces. We always provide a free, detailed quote before starting.',
  'home.faq.q.price_fixed_q': 'Are prices fixed or can they change?',
  'home.faq.q.price_fixed_a': 'Standard services have fixed prices based on apartment type. Extraordinary cleaning is hourly (€30/hour) and defined based on specific needs. All details are listed in the quote.',
  'home.faq.q.discount_q': 'Can I get a discount for recurring services?',
  'home.faq.q.discount_a': 'Yes — for customers with frequent recurring services we evaluate personalized terms. Just contact us to find the best fit.',
  'home.faq.q.advance_q': 'How far in advance should I book?',
  'home.faq.q.advance_a': 'We recommend booking at least 24–48 hours in advance, especially in high season. For urgent requests we always check availability.',
  'home.faq.q.cancel_q': 'Can I change or cancel a booking?',
  'home.faq.q.cancel_a': 'Yes — you can change or cancel up to 24 hours before the appointment with no extra cost. Shorter notice may incur specific terms, communicated at booking time.',
  'home.faq.q.weekend_q': 'Do you operate on weekends and holidays?',
  'home.faq.q.weekend_a': 'Yes, we operate on weekends and holidays too, subject to team availability. In those cases surcharges may apply and are listed in the quote.',
  'home.faq.q.products_q': 'Do you bring the cleaning products?',
  'home.faq.q.products_a': 'Yes — we provide all the necessary professional products. We use high-quality detergents suitable for every surface. On request we can also use specific products supplied by the customer.',
  'home.faq.q.quality_q': 'How do you guarantee service quality?',
  'home.faq.q.quality_a': "Every service follows standardized procedures and is performed by qualified operators. On request we can provide a final photo report. The team's experience and continuous training ensure excellent results.",
  'home.faq.q.how_q': 'How does Halomora work?',
  'home.faq.q.how_a': 'Search for a service in your area, compare verified companies, book in a few clicks and pay online or in cash. You receive instant confirmation and the professional arrives at the agreed time.',
  'home.faq.q.verified_q': 'Are professionals verified?',
  'home.faq.q.verified_a': 'Yes, every company on Halomora is verified and has real reviews from customers. We only feature professionals with high ratings and positive feedback.',
  'home.faq.q.payment_q': 'How does payment work?',
  'home.faq.q.payment_a': 'You can pay online by credit card or in cash to the professional. Online payments are secure and protected. You always receive a receipt by email.',

  // FAQ page
  'faq.seo.title': 'FAQ | Halomora',
  'faq.seo.description': 'Frequently asked questions for customers and businesses: bookings, payments, quotes, recurring services, cancellations and support.',
  'faq.page_title': 'Frequently asked questions (FAQ)',
  'faq.page_subtitle': 'Simple instructions for Customers and Vendors',
  'faq.customer.section_title': 'Customer FAQs (B2C and B2B)',
  'faq.vendor.section_title': 'Vendor FAQs (Companies / Partners)',
  'faq.customer.home_flow.title': 'Customers — From the Home to booking',
  'faq.customer.home_flow.items': 'Go to the Home page.\nChoose the service type (e.g. House cleaning) and press the button.\nIf asked, enter your area / address to see who operates near you.\nPick the company you prefer and press Book on the chosen service to enter the booking page.',
  'faq.customer.single.title': 'Customers — One-off booking',
  'faq.customer.single.items': 'Step 1 Schedule: pick a date from the calendar and a time slot.\nStep 2 Service details: choose the type, set the size in sqm and urgency. If you cannot find what you need, use Request a quote.\nStep 3 Your details: First name, Last name, Email, Phone, Service address. Optionally check Use the same address for billing.\nStep 4 Summary and confirmation: check the details, pick the payment method (Card or Cash to vendor, if available) and press Confirm booking.',
  'faq.customer.recurring.title': 'Customers — Recurring booking (weekly / monthly)',
  'faq.customer.recurring.items': 'In Step 1 Schedule enable the Recurring booking toggle.\nChoose the Frequency (weekly / bi-weekly / monthly) and set an End date.\nComplete Steps 2–4 as for a one-off booking. The summary will show Occurrences and Series total.',
  'faq.customer.quote.title': 'Customers — Requesting a custom quote',
  'faq.customer.quote.items': 'In Step 2 Service details press Cannot find what you need? Request a quote.\nIn the Request a quote dialog enter an approximate area (if known), notes and (optionally) photos.\nPress Send request. You will receive the vendor reply via the platform / email.',
  'faq.customer.changes.title': 'Customers — Changes, cancellations and refunds',
  'faq.customer.changes.items': 'Changes: go to Profile, open the booking and use Edit / Reschedule (if available).\nCancellations: from Profile press Cancel. Any penalties will be shown before confirming.\nRefunds: if you paid by card the refund is processed online (5–10 banking days). For cash, coordinate with the vendor.',
  'faq.customer.auth.title': 'Customers — Sign-up, sign-in and guest',
  'faq.customer.auth.items': 'Sign up / Sign in: use the Sign in / Register button (/auth page).\nWithout an account: during booking, Step 3 Your details lets you Check out as a guest.\nAccount benefits: find your bookings again, edit / cancel more easily and manage your data.',
  'faq.customer.address.title': 'Customers — Address, notes and photos',
  'faq.customer.address.items': 'Address: enter street and number so the vendor can reach you.\nNotes: add special requests under Special instructions.\nPhotos: upload them in Step 2 to help describe the work.',
  'faq.customer.notifications.title': 'Customers — Confirmations, notifications and receipts',
  'faq.customer.notifications.items': 'Confirmations: you receive a confirmation email after booking.\nCard payment: you receive a receipt by email.\nCash: the receipt is handled by the vendor at service time.',
  'faq.customer.privacy.title': 'Customers — Privacy and data',
  'faq.customer.privacy.items': 'GDPR: your data is processed in compliance with the regulation.\nProfile: you can request export or deletion of your data from your profile or by contacting support.',
  'faq.vendor.access.title': 'Vendor — Access and dashboard',
  'faq.vendor.access.items': 'Sign in / register from the Sign in / Register item.\nOpen your Company dashboard from the menu.',
  'faq.vendor.profile_services.title': 'Vendor — Profile and services',
  'faq.vendor.profile_services.items': 'Company profile: upload logo, description, service areas and contacts.\nServices: create / edit with name, description, base price, allowed types, inclusions / benefits.\nPayment methods: enable Card and/or Cash-to-vendor for each service.',
  'faq.vendor.availability.title': 'Vendor — Availability and capacity (avoid overbooking)',
  'faq.vendor.availability.items': 'Set the daily capacity for your working dates.\nUpdate for holidays or peaks. Fully booked dates are disabled on the customer calendar.',
  'faq.vendor.bookings.title': 'Vendor — Booking management and recurrences',
  'faq.vendor.bookings.items': 'Bookings inbox: new requests appear at the top (you receive email if enabled).\nReject / Reschedule: open the booking and use the dedicated actions, communicating with the customer.\nRecurrences: view occurrences, suspend single dates (if enabled), close the series if needed.',
  'faq.vendor.quotes.title': 'Vendor — Custom quotes',
  'faq.vendor.quotes.items': 'Open the Quotes section.\nReview surface area, notes and photos.\nSend a proposal with price, timing and conditions; if the customer accepts, convert it to a booking.',
  'faq.vendor.payments.title': 'Vendor — Payments, refunds and disputes',
  'faq.vendor.payments.items': 'Payments: for Card you find status and receipt in the booking; for Cash issue the receipt according to regulation.\nRefunds: from the booking detail start a full / partial refund according to policy.\nDisputes (chargeback): follow notifications and upload evidence; pause sensitive actions until the dispute is closed.',
  'faq.vendor.reporting.title': 'Vendor — Reporting and export',
  'faq.vendor.reporting.items': 'Dashboard: review bookings, recurrences, revenue, refunds and reviews.\nExport: use Export CSV when available for accounting and analysis.',
  'faq.vendor.offers.title': 'Vendor — Seasonal offers',
  'faq.vendor.offers.items': 'Open the Dashboard and go to the Offers section.\nCreate an offer with name, discount (%) and period.\nAssociate the chosen service and activate the offer.',
  'faq.vendor.paymethods.title': 'Vendor — Payment methods and fees',
  'faq.vendor.paymethods.items': 'For each service enable Card and/or Cash.\nIf you cover the customer fees, the price shown to the customer already includes them.',
  'faq.vendor.cancel_policy.title': 'Vendor — Cancellation and refund policy',
  'faq.vendor.cancel_policy.items': 'Define windows and penalties in the service settings.\nFor refunds: use the booking detail for full / partial refunds according to policy.',
  'faq.vendor.messaging.title': 'Vendor — Communications with customers',
  'faq.vendor.messaging.items': 'Use clear notes / descriptions in bookings and quotes.\nConfirm quickly and notify promptly in case of changes.',
  'faq.vendor.security.title': 'Vendor — Data and compliance',
  'faq.vendor.security.items': 'Keep company data and contacts up to date.\nManage documents, receipts and customer data in compliance with current regulations.',

  // Legal pages + Landing + AuthReset + Auth
  'legal.last_updated': 'Last updated: {{date}}',
  'legal.privacy.title': 'Privacy Policy',
  'legal.privacy.open_link': 'Open the Privacy Policy',
  'legal.privacy.fallback': 'Display issues? Open the policy on iubenda.com.',
  'legal.privacy.fallback_link': 'Open the policy on iubenda.com',
  'legal.cookies.title': 'Cookie Policy',
  'legal.cookies.intro': 'Read our updated Cookie Policy and manage your cookie preferences.',
  'legal.cookies.open_link': 'Open the Cookie Policy',
  'legal.cookies.fallback_prefix': 'You can also',
  'legal.cookies.fallback_link': 'open the cookie policy on iubenda.com',
  'legal.aup.title': 'Acceptable Use Policy',
  'legal.aup.intro': 'You agree not to use the services for unlawful activities, harassment, spam, or any actions that could harm others, the platform, or our partners.',
  'legal.aup.item.fraud': 'No fraudulent or deceptive conduct',
  'legal.aup.item.access': 'No unauthorized access attempts',
  'legal.aup.item.abuse': 'No abuse or harassment of vendors or customers',
  'legal.imprint.title': 'Imprint / Legal Notice',
  'legal.imprint.operator': 'Operator',
  'legal.imprint.address': 'Address',
  'legal.imprint.email': 'Email',
  'legal.imprint.website': 'Website',
  'legal.imprint.vat': 'VAT / Tax ID',
  'legal.imprint.vat_value': '(if applicable)',
  'legal.imprint.note': 'This site is a marketplace that connects customers with independent vendors. Services are provided by the respective vendors. For information about data processing, see our',
  'legal.imprint.privacy_link': 'Privacy Policy',
  'legal.refund.title': 'Refund Policy',
  'legal.refund.intro': 'Refund eligibility depends on service type, cancellation timing, and vendor confirmation. If you believe you are entitled to a refund, contact support with your booking details.',
  'legal.refund.cancellations_title': 'Cancellations',
  'legal.refund.cancellations_body': 'Same-day cancellations may incur a fee. No-shows are generally non-refundable.',
  'legal.subp.title': 'Subprocessors',
  'legal.subp.intro': 'We engage the following subprocessors to provide our services. Each subprocessor is bound by a Data Processing Agreement (DPA) with appropriate security and transfer safeguards. For the current list, consult this page or contact us for details.',
  'legal.subp.col.name': 'Name',
  'legal.subp.col.purpose': 'Purpose',
  'legal.subp.col.location': 'Location',
  'legal.subp.col.dpa': 'DPA / Privacy',
  'legal.subp.learn_more': 'Learn more',
  'legal.subp.supabase.purpose': 'Managed Postgres DB, auth, storage',
  'legal.subp.vercel.purpose': 'Application hosting & CDN',
  'legal.subp.stripe.purpose': 'Payment processing & payouts',
  'legal.subp.resend.purpose': 'Transactional email delivery',
  'legal.subp.google.purpose': 'Identity provider & calendar sync',
  'legal.subp.iubenda.purpose': 'Privacy & Cookie policy hosting/CMP',
  'legal.dpa.title': 'Data Processing Addendum (DPA)',
  'legal.dpa.intro': 'This DPA forms part of the Terms and governs the processing of personal data by Halomora on behalf of customers. It includes our commitments regarding security, confidentiality, sub-processors, data subject rights, and international transfers.',
  'legal.dpa.subp_title': 'Sub-processors',
  'legal.dpa.subp.supabase': 'Supabase (database and authentication)',
  'legal.dpa.subp.vercel': 'Vercel or Netlify (hosting)',
  'legal.dpa.subp.sentry': 'Sentry (error monitoring) — optional',
  'legal.vendor.title': 'Vendor Services Agreement',
  'legal.vendor.intro': 'This Vendor Services Agreement ("Agreement") governs participation by service providers ("Vendors") on the Halomora platform.',
  'legal.vendor.h1': '1. Vendor Obligations',
  'legal.vendor.p1': 'Vendors must maintain valid licenses and insurance, provide accurate service listings and pricing, and deliver services with reasonable care and skill.',
  'legal.vendor.h2': '2. Fees and Payouts',
  'legal.vendor.p2': 'Platform fees and payout schedules are determined by Halomora policies and may be updated from time to time with notice.',
  'legal.vendor.h3': '3. Limited Payment Collection Agent',
  'legal.vendor.p3': 'Vendor appoints Halomora as its limited payments collection agent solely for the purpose of accepting funds from customers via our payment processor and remitting those funds to Vendor, net of applicable fees, taxes, chargebacks, or refunds. Customer payment to Halomora is deemed payment to Vendor. Halomora is not a payment institution and does not operate or hold funds on behalf of Vendor beyond this limited agency.',
  'legal.vendor.h3b': 'Stripe Connect Onboarding',
  'legal.vendor.p3b': 'Halomora may rely on Stripe Connect for payouts. Vendor agrees to complete Stripe\'s onboarding (including identity verification and bank account setup) and comply with Stripe\'s terms, as well as applicable anti-money laundering and sanctions requirements.',
  'legal.vendor.h4': '4. Compliance',
  'legal.vendor.p4': 'Vendors agree to comply with applicable laws and our Acceptable Use Policy. Failure to comply may result in suspension or termination.',
  'legal.terms.title': 'Terms and conditions',
  'legal.terms.notice': 'The Italian version is the authoritative one. Translations are provided for convenience only.',
  'landing.servizio.fallback_h1': 'Service unavailable',
  'landing.servizio.search_cta': 'Search services',
  'landing.servizio.book_cta': 'Book now',
  'landing.servizio.related_title': 'Services related to {{city}}',
  'landing.azienda.title_prefix': 'Cleaning companies in',
  'landing.azienda.subtitle': 'Compare verified professionals near you, read reviews and book online.',
  'landing.azienda.cta_search': 'Find companies in {{city}}',
  'authreset.title': 'Reset your password',
  'authreset.subtitle': 'Enter a new password for your account.',
  'authreset.new_password': 'New password',
  'authreset.confirm_password': 'Confirm password',
  'authreset.cta': 'Update password',
  'authreset.loading': 'Updating...',
  'authreset.success_title': 'Password updated',
  'authreset.success_desc': 'Your password has been updated. You can now sign in.',
  'authreset.error_title': 'Error',
  'authreset.error_mismatch': 'Passwords do not match.',
  'authreset.error_short': 'Password must be at least 8 characters.',
  'authreset.back_to_signin': 'Back to sign in',
  'authreset.invalid_link': 'The reset link is invalid or expired. Request a new link from the sign-in page.',
  'auth.toggle.have_account': 'Already have an account? Sign in',
  'auth.toggle.no_account': 'Don\'t have an account? Sign up',
  'auth.field.email': 'Email',
  'auth.field.password': 'Password',
  'auth.field.first_name': 'First name',
  'auth.field.last_name': 'Last name',
  'auth.field.phone': 'Phone',
  'auth.forgot_password': 'Forgot password?',
  'auth.continue_with_google': 'Continue with Google',
  'auth.or': 'or',
  'auth.terms_notice': 'By continuing you accept the Terms and the Privacy Policy.',
  'auth.send_reset_link': 'Send reset link',
  'auth.reset_sent_title': 'Email sent',
  'auth.reset_sent_desc': 'Check your inbox for the reset link.',

  // Landing servizio/azienda + AuthReset extras
  'landing.servizio.not_found_title': 'Service not found',
  'landing.servizio.not_found_body_prefix': 'Go back to the',
  'landing.servizio.not_found_body_link': 'homepage',
  'landing.servizio.not_found_body_suffix': 'to discover all services.',
  'landing.servizio.cta_hero': 'Find a Professional',
  'landing.servizio.section_services': 'Our services',
  'landing.servizio.section_how': 'How it works',
  'landing.servizio.how_1_strong': 'Describe your need',
  'landing.servizio.how_1_text': '— enter your address and service type',
  'landing.servizio.how_2_strong': 'Receive free quotes',
  'landing.servizio.how_2_text': '— local businesses contact you within 24h',
  'landing.servizio.how_3_strong': 'Choose and book',
  'landing.servizio.how_3_text': '— compare and confirm on Halomora',
  'landing.servizio.section_zones': 'Covered areas',
  'landing.servizio.zones_body': 'We operate in {{zones}}. Contact us to verify coverage in your specific area.',
  'landing.servizio.section_faq': 'Frequently asked questions',
  'landing.servizio.cta_final_title': 'Ready to book?',
  'landing.servizio.cta_final_btn': 'Find a Professional in {{city}}',
  'landing.azienda.not_found_title': 'Page not found',
  'landing.azienda.not_found_body_prefix': 'Go back to the',
  'landing.azienda.not_found_body_link': 'homepage',
  'landing.azienda.hero_title': 'Grow Your Cleaning Business in {{city}}',
  'landing.azienda.hero_body': 'Halomora connects cleaning businesses with customers in {{city}} and the surrounding areas ({{zones}}). Register for free and start receiving requests in your area.',
  'landing.azienda.cta_register': 'Register Your Company',
  'landing.azienda.section_why': 'Why use Halomora',
  'landing.azienda.why_1_strong': 'Zero commission to start',
  'landing.azienda.why_1_text': '— free trial with no fixed cost',
  'landing.azienda.why_2_strong': 'Geo-located customers',
  'landing.azienda.why_2_text': '— requests from your operating area',
  'landing.azienda.why_3_strong': 'Immediate visibility',
  'landing.azienda.why_3_text': '— profile visible to anyone searching for cleaning in {{city}}',
  'landing.azienda.why_4_strong': 'Easy management',
  'landing.azienda.why_4_text': '— quotes and appointments in one place',
  'landing.azienda.section_how': 'How it works',
  'landing.azienda.how_1_strong': 'Create your free profile',
  'landing.azienda.how_1_text': '— describe services and covered area',
  'landing.azienda.how_2_strong': 'Receive notifications',
  'landing.azienda.how_2_text': '— alerts for every new request in your area',
  'landing.azienda.how_3_strong': 'Manage everything in Halomora',
  'landing.azienda.how_3_text': '— quotes, customers and appointments',
  'landing.azienda.section_zones': 'Covered areas',
  'landing.azienda.zones_body': 'We operate in {{zones}}.',
  'landing.azienda.final_title': 'Be Among the First in {{city}}',
  'landing.azienda.final_body': 'The first businesses to sign up get priority visibility in local searches.',
  'authreset.validating': 'Validating link…',
  'authreset.go_signin': 'Go to sign in',
  'authreset.try_from_profile': 'Try again from Profile',
  'authreset.saving': 'Saving…',
  'authreset.seo_title': 'Reset password | Halomora',
  'authreset.too_many_attempts_title': 'Too many attempts',
  'authreset.too_many_attempts_desc': 'You have made too many attempts in a short time. Please retry in a few minutes.',
  'authreset.verification_required_title': 'Verification required',
  'authreset.verification_required_desc': 'Please verify with your authenticator code to continue.',
  'authreset.update_failed': 'Failed to update password.',
  'cookies.consent.message': 'We use cookies for essential features and to understand usage. See our',
  'cookies.consent.cookie_policy': 'Cookie Policy',
  'cookies.consent.and': 'and',
  'cookies.consent.privacy_policy': 'Privacy Policy',
  'cookies.consent.essential_only': 'Essential only',
  'cookies.consent.accept_all': 'Accept all',
  'cookies.preferences.title': 'Cookie preferences',
  'cookies.preferences.analytics.title': 'Analytics & performance',
  'cookies.preferences.analytics.description': 'Help us improve via anonymous usage metrics and session replay.',
  'cookies.preferences.cancel': 'Cancel',
  'cookies.preferences.save': 'Save preferences',
  'support.seo_title': 'Support | Issues & claims | Halomora',
  'support.title': 'Issues & claims',
  'support.subtitle': 'Open a ticket on a booking, upload evidence, and track the status.',
  'support.back_to_profile': 'Back to profile',
  'support.status.opened': 'Open',
  'support.status.awaiting_vendor': 'Waiting for company',
  'support.status.awaiting_customer': 'Waiting for customer',
  'support.status.resolved': 'Resolved',
  'support.role.vendor': 'Company',
  'support.role.customer': 'Customer',
  'support.role.system': 'System',
  'support.toast.photos_upload_failed_title': 'Photos not uploaded',
  'support.toast.photos_upload_failed_desc': "The ticket was created, but we couldn't upload the photos. Please try again or send them as a message in the ticket.",
  'support.new_ticket.title': 'Open a new ticket',
  'support.new_ticket.select_booking': 'Select booking',
  'support.new_ticket.select_type': 'Issue type',
  'support.new_ticket.note_placeholder': 'Describe the issue (what happened, when, what you expect).',
  'support.new_ticket.attach_evidence': 'Attach evidence (photos)',
  'support.new_ticket.creating': 'Creating…',
  'support.new_ticket.create': 'Create ticket',
  'support.tickets.title': 'Tickets',
  'support.loading': 'Loading…',
  'support.fallback.service': 'Service',
  'support.fallback.company': 'Company',
  'support.fallback.issue': 'Issue',
  'support.empty_tickets': 'No tickets yet.',
  'support.select_ticket_hint': 'Select a ticket on the left.',
  'support.ticket_title_fallback': 'Ticket',
  'support.ticket_meta.status': 'Status',
  'support.ticket_meta.booking': 'Booking',
  'support.empty_messages': 'No messages.',
  'support.reply_placeholder': 'Reply…',
  'support.sending': 'Sending…',
  'support.send_reply': 'Send reply',
  'am.seo.title': 'Cleaning Companies Jesolo | Vacation Rental Cleaning Veneto | Halomora for Property Managers',
  'am.seo.description': 'Looking for cleaning companies in Jesolo or Veneto for your apartments? Halomora helps property managers find reliable partners, manage turnovers with AI and keep everything under control in one platform.',
  'am.hero.badge': 'For property managers and apartment managers — Jesolo, Veneto and surrounding areas',
  'am.hero.title': 'Apartment cleaning in Jesolo? Manage everything in one place.',
  'am.hero.subtitle': 'Halomora helps you find reliable cleaning companies in Veneto, coordinate turnovers without chasing messages and calls, and track every job in a central dashboard. From single bookings to batches of 50 in one click.',
  'am.hero.cta_talk': 'Let\'s talk',
  'am.hero.cta_bulk': 'Already have a supplier? Use Bulk Order',
  'am.hero.pill.verified': 'Verified cleaning companies',
  'am.hero.pill.batch': 'AI booking up to 50 turnovers',
  'am.hero.pill.tower': 'Live availability Control Tower',
  'am.problem.title': 'The problem every season in Jesolo',
  'am.problem.p1': 'In Jesolo and the Venetian coast, cleaning companies are often fully booked between March and April. Those who arrive late only find residual capacity.',
  'am.problem.p2': 'Managing 10, 20 or 50 apartments with scattered WhatsApp messages and last-minute calls is unsustainable in high season.',
  'am.problem.p3': 'Halomora centralizes everything: find suppliers, book in batch, see real availability and keep accounts in order — without extra software.',
  'am.features.title': 'Everything you need to manage cleaning',
  'am.features.subtitle': 'A platform built for vacation rental managers in Jesolo and Veneto — not generic software.',
  'am.fit.badge': 'Made for you if...',
  'am.fit.title': 'Built for vacation rental managers in Veneto',
  'am.fit.subtitle': 'You don\'t need to be a large agency. Halomora is useful even if you manage 5–10 apartments in Jesolo and want to stop chasing suppliers every season.',
  'am.fit.items': 'You manage multiple apartments or a growing portfolio in Jesolo, Cavallino or Caorle.\nYou want consistent cleaning standards without renegotiating every summer.\nYou need to book dozens of turnovers quickly without mistakes.\nYou need real availability, not verbal confirmations that fall through at the last minute.',
  'am.how.title': 'How it works',
  'am.how.1.title': 'Needs analysis',
  'am.how.1.text': 'Capacity, areas, turnover windows, quality standards, seasonal peaks and current pain points.',
  'am.how.2.title': 'Partner selection',
  'am.how.2.text': 'We evaluate cleaning companies compatible with required volumes and continuity.',
  'am.how.3.title': 'Operational setup',
  'am.how.3.text': 'We define service scope and the most practical interface for requests and coordination.',
  'am.how.4.title': 'In-platform management',
  'am.how.4.text': 'When it makes sense, we connect turnover management to Bulk Order and other app flows.',
  'am.cta_find.badge': 'Not sure where to start?',
  'am.cta_find.title': 'Don\'t have a supplier yet? We\'ll help you find one.',
  'am.cta_find.body': 'If you don\'t have continuous cleaning coverage for Jesolo or Veneto yet, start with the form below. We\'ll review area, volumes and frequency together and connect you with partners suited to your season. If you already have a supplier, use Bulk Order in the app.',
  'am.cta_find.btn_find': 'Find a cleaning partner',
  'am.cta_find.btn_have': 'I already have a supplier',
  'am.batch.badge': 'AI Booking Batch',
  'am.batch.title': '50 bookings in one click instead of hours of messages',
  'am.batch.body': 'Upload your apartment list with checkout, check-in and available windows. AI suggests optimal coverage, flags at-risk turnovers and tells you exactly where to confirm, advance or find an extra supplier. No more Excel sheets or scattered chats.',
  'am.batch.grid.apartments': 'Apartments',
  'am.batch.grid.apartments_desc': 'import your list',
  'am.batch.grid.windows': 'Turnover windows',
  'am.batch.grid.windows_desc': 'checkout → check-in',
  'am.batch.grid.ai': 'AI coverage',
  'am.batch.grid.ai_desc': 'suggested automatically',
  'am.batch.grid.alert': 'Risk alert',
  'am.batch.grid.alert_desc': 'slots to confirm',
  'am.batch.btn_talk': 'Let\'s talk',
  'am.batch.btn_try': 'Try Bulk Order',
  'am.form.title': 'Request contact',
  'am.form.success': 'Request received. We\'ll get back to you about coverage, timing and volumes to manage.',
  'am.form.contact_name': 'Contact name',
  'am.form.company_name': 'Company / property name',
  'am.form.email': 'Work email',
  'am.form.phone': 'Phone',
  'am.form.area': 'Area / resort location',
  'am.form.apartments': 'Number of apartments / units',
  'am.form.season': 'Period and continuity required (e.g. April–September, 7/7)',
  'am.form.needs': 'Describe your needs: volumes, timing between checkout and check-in, quality standards, issues with current suppliers, areas to cover.',
  'am.form.hint': 'Suggested message: tell us where you operate, how many apartments you manage and why you need continuous coverage.',
  'am.form.submitting': 'Sending...',
  'am.form.sent': 'Request sent',
  'am.form.submit': 'I want to be contacted',
  'am.zones.title': 'Areas served',
  'am.zones.items': 'Jesolo and the Venetian coast\nCavallino-Treporti and lagoon\nCaorle, Bibione, Eraclea\nVenice and Veneto municipalities',
  'am.links.title': 'Useful paths',
  'am.links.bulk': 'Bulk Order for recurring turnovers',
  'am.links.vendor': 'Are you a cleaning company? See how to join',
  'am.links.search': 'Search cleaning services',
  'am.faq.title': 'Frequently asked questions',
  'am.faq.subtitle': 'Quick answers to see if this model fits your case.',
  'am.toast.sent_title': 'Request sent',
  'am.toast.sent_desc': 'We\'ll contact you soon about coverage, timing and volumes.',
  'am.toast.failed_title': 'Send failed',
  'am.toast.failed_desc': 'Unknown error',
  'am.toast.error_send': 'Error while sending the request',
  'am.form.msg.contact': 'Contact:',
  'am.form.msg.apartments': 'Apartments/units:',
  'am.form.msg.season': 'Period/operations:',
  'am.form.msg.needs_label': 'Need:',
  'am.form.msg.unspecified': '(not specified)',
  'am.feature.1.title': 'Central hub for cleaning companies',
  'am.feature.1.desc': 'Find, evaluate and book cleaning companies in Jesolo and Veneto in one place. Verified profiles, real reviews, updated availability — no more scattered WhatsApp searches.',
  'am.feature.2.title': 'Centralized spend and services dashboard',
  'am.feature.2.desc': 'Track every job, expense and supplier in one dashboard. See top services, seasonal costs and how work is distributed across your apartments.',
  'am.feature.3.title': 'AI Booking Batch — up to 50 bookings',
  'am.feature.3.desc': 'Upload up to 50 jobs in one operation. AI reads turnover windows, suggests optimal coverage and flags at-risk slots — hours of work reduced to minutes.',
  'am.feature.4.title': 'Real-time Turnover Control Tower',
  'am.feature.4.desc': 'A live view of real cleaning company availability. The calendar reflects actual supplier capacity — no more verbal confirmations that fail at the last minute.',
  'am.faq.1.q': 'Is Halomora the cleaning company or an intermediary?',
  'am.faq.1.a': 'Halomora acts as the organizing counterpart: it selects reputable cleaning companies in Jesolo and Veneto, structures the service and remains your operational/commercial contact. Depending on the case, work is then delivered in outsourcing by qualified partners.',
  'am.faq.2.q': 'Which properties is this service for?',
  'am.faq.2.a': 'It is designed for apartment managers, property managers and vacation rental operators who need reliable turnovers during high season, especially in destinations like Jesolo, Cavallino, Caorle, Bibione and Eraclea where operational pressure peaks from May to September.',
  'am.faq.3.q': 'What does \'AI Booking Batch\' mean?',
  'am.faq.3.a': 'Instead of creating each booking manually, you can upload up to 50 jobs in one operation — with turnover windows, apartments and dates pre-filled. AI suggests optimal coverage and warns about at-risk slots.',
  'am.faq.4.q': 'How does the Turnover Control Tower work?',
  'am.faq.4.a': 'It is a real-time view of connected cleaning companies\' availability. What you see on the calendar reflects real supplier capacity, not estimates: you immediately know who can cover the next turnover and where SLA risk exists.',
  'am.faq.5.q': 'What happens after submitting the form?',
  'am.faq.5.a': 'We contact you to understand area, number of apartments, turnover frequency, required standards and season pain points. If there is operational fit, we propose a continuous solution with partners suited to your area — Jesolo, Veneto and surroundings first.',
  'business.nav.back_home': 'Back to Home',
  'business.seo.title': 'Cleaning Businesses: More Clients and Bookings With No Fixed Costs | Halomora',
  'business.seo.description': 'Software and marketplace for cleaning businesses: free registration, online storefront, Halomora marketplace clients, booking manager and calendar. No subscription — pay only when you receive orders.',
  'business.hero.badge': 'For cleaning businesses',
  'business.hero.title': 'The simplest way to grow your cleaning business',
  'business.hero.subtitle': 'Sign up free on Halomora, get clients from the marketplace, a professional online storefront and everything under control in one place. No fixed costs: you pay only when you receive an order.',
  'business.hero.cta_signup': 'Sign up free',
  'business.hero.cta_how': 'How it works',
  'business.hero.stat1.label': '€0 to start',
  'business.hero.stat1.sub': 'no subscription',
  'business.hero.stat2.label': 'Marketplace clients',
  'business.hero.stat2.sub': 'not just software',
  'business.hero.stat3.label': 'From 5%',
  'business.hero.stat3.sub': 'on received orders',
  'business.showcase.label': 'Your Halomora storefront',
  'business.showcase.title': 'Visible to people searching for cleaning',
  'business.showcase.row1': 'Online company profile',
  'business.showcase.row2': 'Published services and prices',
  'business.showcase.row3': 'Marketplace requests',
  'business.showcase.row4': 'Organized calendar and orders',
  'business.showcase.hint': 'Example typical path after registration — online in minutes.',
  'business.problem.badge': 'The problem',
  'business.problem.title': 'Growing with cleaning shouldn\'t mean more chaos',
  'business.problem.desc': 'If you recognize at least one of these points, Halomora is built for you.',
  'business.solution.badge': 'The solution',
  'business.solution.title': 'More clients, online storefront and organized work — with no fixed costs',
  'business.solution.desc': 'Halomora combines marketplace, free mini-site and practical tools for cleaning businesses that want to grow without complications.',
  'business.vitrine.badge': 'Free mini-site',
  'business.vitrine.title': 'Your professional storefront, ready as soon as you register',
  'business.vitrine.desc': 'You don\'t need an expensive website to start. With Halomora you immediately get a company page in the marketplace, shareable with clients and visible to people searching for cleaning in your area.',
  'business.vitrine.lines': 'Professional page with services, areas and contacts\nLink to share on WhatsApp, email or social\nPresence in the Halomora marketplace\nMore credibility than just a phone number',
  'business.vitrine.sample_url': 'halomora.com/your-company',
  'business.vitrine.sample_name': 'Cleaning Company · Jesolo',
  'business.vitrine.sample_desc': 'Apartment, office and post-construction cleaning',
  'business.vitrine.custom_site': 'Want a dedicated website on your own domain? We build it as an optional quoted service.',
  'business.vitrine.cta': 'Discover website and marketing',
  'business.benefits.badge': 'What you get',
  'business.benefits.title': 'Everything you need to work better, in one place',
  'business.benefits.desc': 'Booking manager, calendar and payments — explained simply, with concrete benefits for your cleaning business.',
  'business.free.badge_forever': 'Free forever',
  'business.free.badge_no_sub': 'No monthly subscription',
  'business.free.title': 'Free registration. Pay only when you receive orders.',
  'business.free.desc': 'Halomora applies a commission from 5% only on orders you receive through the platform (depending on plan). No upfront cost, no end-of-month surprises.',
  'business.free.includes': 'Company page in the Halomora marketplace\nShareable storefront for your clients\nRequests and bookings from platform users\nCalendar, orders and team management\nTracked payments and transparent commission (from 5% on received orders)',
  'business.free.cta': 'Create your free profile',
  'business.free.hint': 'About 5 minutes · No card required to start',
  'business.onboarding.badge': 'Start in 5 minutes',
  'business.onboarding.title': 'Four steps and you\'re live',
  'business.onboarding.desc': 'No complicated bureaucracy. We guide you step by step from registration to first orders.',
  'business.optional.badge': 'Optional upgrade',
  'business.optional.title': 'Want to sell more online? We also help with website and marketing',
  'business.optional.desc': 'The Halomora profile stays free. Website and campaigns are quoted services for those who want to accelerate growth.',
  'business.portfolio.badge': 'Real example',
  'business.portfolio.title': 'Websites built for cleaning companies',
  'business.portfolio.desc': 'A concrete example of what we can do for your business.',
  'business.portfolio.visit': 'Visit jservicejesolo.com',
  'business.portfolio.disclaimer': 'The site is owned by the client: we show it as a quality and style reference.',
  'business.testimonials.title': 'What businesses using Halomora say',
  'business.testimonials.company_fallback': 'Company',
  'business.cta.title': 'Ready to get more cleaning bookings in your area?',
  'business.cta.desc': 'Join Halomora free. No subscription, no initial risk — only a commission when work actually arrives.',
  'business.cta.signup': 'Sign up free now',
  'business.cta.talk': 'Talk to us',
  'business.local.title': 'Cleaning business in your area?',
  'business.local.desc': 'Dedicated pages for cleaning businesses that want clients in Jesolo, Venice and Veneto.',
  'business.local.btn': 'Cleaning in {{city}}',
  'business.transparency': 'Transparency: Halomora does not guarantee fixed client volumes. Results depend on area, seasonality and profile quality. Our goal is to help you get found more easily and work in a more organized way.',
  'business.sales.title': 'Questions? Contact us',
  'business.form.sent_title': 'Request sent!',
  'business.form.sent_desc': 'We\'ll get back to you by email as soon as possible.',
  'business.form.company': 'Company name',
  'business.form.email': 'Work email',
  'business.form.phone': 'Phone (optional)',
  'business.form.region': 'City / Region',
  'business.form.interest': 'What are you interested in?',
  'business.form.chip.free': 'Free profile',
  'business.form.chip.site': 'Website',
  'business.form.chip.site_mkt': 'Website + marketing',
  'business.form.chip.mkt': 'Marketing only',
  'business.form.message': 'Tell us about your cleaning business (area, services, goals)',
  'business.form.submitting': 'Sending…',
  'business.form.sent_btn': 'Sent ✓',
  'business.form.submit': 'Send',
  'business.faq.title': 'Frequently asked questions',
  'business.plans.badge': 'Plans',
  'business.plans.title': 'Choose your support level',
  'business.plans.desc': 'You can start free and move to PRO or SCALE when you want to test marketing with more support.',
  'business.plans.commission': 'Commission: {{rate}}',
  'business.toast.failed_title': 'Send failed',
  'business.toast.failed_desc': 'Unknown error',
  'business.toast.error_send': 'Error sending request',
  'business.toast.thanks_title': 'Thank you!',
  'business.toast.thanks_desc': 'Request sent successfully. We\'ll get back to you soon.',
  'business.period.month': '/month',
  'business.period.from': 'From',
  'business.period.quote': 'On quote',
  'business.min.6': 'Minimum 6 months',
  'business.min.12': 'Minimum 12 months',
  'business.pain.1': 'Too many messages scattered across WhatsApp, email and Excel sheets.',
  'business.pain.2': 'Clients ask for quotes but then get lost in follow-up.',
  'business.pain.3': 'Hard to get found online without investing in an expensive website.',
  'business.pain.4': 'In high season the risk is saying yes to too much work and then not keeping up.',
  'business.pillar.1.title': 'More clients, no fixed costs',
  'business.pillar.1.desc': 'Free registration, no monthly subscription. You pay a commission only when you receive an order through Halomora.',
  'business.pillar.2.title': 'Online storefront ready immediately',
  'business.pillar.2.desc': 'Get a professional marketplace page, shareable with your clients and visible to people searching for cleaning.',
  'business.pillar.3.title': 'Demand from the marketplace',
  'business.pillar.3.desc': 'Halomora users can find and book you directly. It\'s not just software: it also brings requests.',
  'business.benefit.1.title': 'Bookings and payments in one place',
  'business.benefit.1.desc': 'See orders, paid and due payments, invoices and booking status without jumping between apps.',
  'business.benefit.2.title': 'Calendar and team more organized',
  'business.benefit.2.desc': 'Plan days, coordinate staff and reduce double confirmations or overbooking.',
  'business.benefit.3.title': 'Services and prices that convert',
  'business.benefit.3.desc': 'Present what you offer, at what price and for which areas more clearly. More clarity for clients, more useful requests for you.',
  'business.benefit.4.title': 'Simple numbers to grow',
  'business.benefit.4.desc': 'Understand which services work, how bookings perform and where to invest time and resources.',
  'business.onboarding.1.title': 'Create your account',
  'business.onboarding.1.text': 'Email and password or Google sign-in. Confirm email and you\'re in.',
  'business.onboarding.2.title': 'Present your company',
  'business.onboarding.2.text': 'Name, contacts, business description and profile photo (recommended). VAT optional.',
  'business.onboarding.3.title': 'Add services and prices',
  'business.onboarding.3.text': 'Specify what you offer, for which areas and at what price. Halomora commission is clear from the start.',
  'business.onboarding.4.title': 'Enable payments',
  'business.onboarding.4.text': 'Connect your account in minutes to receive transfers directly when you work.',
  'business.tier.free.headline': 'To test the channel risk-free.',
  'business.tier.pro.headline': 'To test seriously with tracking and local targeting.',
  'business.tier.scale.headline': 'To scale with continuous optimization and dedicated landing pages.',
  'business.tier.ultra.headline': 'Full management of social, brand and campaigns. On quote.',
  'business.tier.free.includes': 'Company profile in the marketplace\nQuote request form\nLead management\nBookings and calendar management\nPayments and invoicing',
  'business.tier.free.excludes': 'Advertising\nSEO\nAdvanced marketing support',
  'business.tier.free.cta': 'Start free',
  'business.tier.pro.includes': 'Everything in FREE\nConversion-optimized marketplace profile\nAnalytics (performance and booking trends)\nGoogle Ads setup and management\nAds budget on Google up to €75/month\nLocal targeting\nConversion tracking',
  'business.tier.scale.includes': 'Everything in PRO\nDedicated landing page with A/B testing\nAds budget on Google up to €200/month\nContinuous campaign optimization\nBasic local SEO (Google Business Profile)\nMonthly report\nPriority support',
  'business.tier.ultra.includes': 'Everything in SCALE\nFull social campaign management (creation, copy, calendar)\nMeta Ads setup and management (targeting, creatives, recommended budget)\nBrand management (guidelines, tone of voice, assets)\nStrategic consulting and dedicated reports\nDedicated support (account manager)',
  'business.tier.free.name': 'FREE PLAN',
  'business.tier.free.price': '0€',
  'business.tier.free.commission': '15%',
  'business.tier.pro.name': 'PRO PLAN',
  'business.tier.pro.price': '99€',
  'business.tier.pro.commission': '10%',
  'business.tier.scale.name': 'SCALE PLAN',
  'business.tier.scale.price': '299€',
  'business.tier.scale.commission': '7%',
  'business.tier.ultra.name': 'ULTRA PLAN',
  'business.tier.ultra.price': '599€',
  'business.tier.ultra.commission': '5%',
  'business.tier.pro.cta': 'Create profile and activate PRO',
  'business.tier.scale.cta': 'Create profile and activate SCALE',
  'business.tier.ultra.cta': 'Book a call',
  'business.service.site.name': 'Professional website',
  'business.service.site.headline': 'A curated online storefront for your cleaning business.',
  'business.service.site.cta': 'Request website quote',
  'business.service.site.bullets': 'Custom mobile-first design\nBasic SEO (titles, structure, meta, schema)\nServices, reviews and contact sections\nIntegrated quote request form\n1-2 revision rounds included',
  'business.service.site_marketing.name': 'Website + marketing support',
  'business.service.site_marketing.headline': 'New storefront + qualified traffic continuously.',
  'business.service.site_marketing.cta': 'Request website + marketing',
  'business.service.site_marketing.bullets': 'Everything in the website package\nGoogle Ads setup with recommended budget\nConversion tracking (forms, calls, WhatsApp)\nMonthly campaign optimization\nReadable monthly report',
  'business.service.marketing.name': 'Marketing support only',
  'business.service.marketing.headline': 'You already have a site and need traffic, leads, local coverage.',
  'business.service.marketing.cta': 'Request marketing only',
  'business.service.marketing.bullets': 'Audit of existing Google Ads / Meta\nSetup of new campaigns (search, local, performance max)\nConversion tracking and attribution\nOptimization and budget management\nMonthly report with commercial KPIs',
  'business.template.free_signup': 'Hi, I\'d like to create my free company profile on Halomora.\n\nCompany details:\n- Company name: \n- City / work area: \n- Main service type (e.g. apartment cleaning, post-construction, offices): \n- Years in business: \n- Current website (if any): \n- WhatsApp / phone contact: \n- Additional notes: \n',
  'business.template.site': 'Hi, I\'m interested in a custom website for my company.\n\nProject details:\n- Company name: \n- City / work area: \n- Sector (residential, industrial, post-construction, condos, etc.): \n- Current website (if any): \n- Do you already have a domain or need help registering one? \n- Desired go-live timeline: \n- References / sites you like (optional): \n- Indicative budget: \n- Additional notes: \n',
  'business.template.site_marketing': 'Hi, I\'m interested in the website + marketing support package.\n\nProject details:\n- Company name: \n- City / work area: \n- Main sector: \n- Current website (if any): \n- Are you already advertising online? Which channels (Google, Meta, TikTok)? \n- Main goal (e.g. acquire clients in area X, fill season, post-construction): \n- Indicative monthly Ads budget: \n- Desired website go-live timeline: \n- Additional notes: \n',
  'business.template.marketing': 'Hi, I already have a website and would like marketing support only.\n\nCurrent details:\n- Company name: \n- City / work area: \n- Sector: \n- Current website URL: \n- Active marketing channels (Google Ads, Meta, SEO, flyers, word of mouth): \n- Current monthly Ads spend: \n- What you\'d like to improve (more leads, lead quality, cost per lead, coverage, conversion): \n- Indicative monthly budget: \n- Additional notes: \n',
  'business.portfolio.jservice.client': 'JService',
  'business.portfolio.jservice.city': 'Jesolo (VE)',
  'business.portfolio.jservice.sector': 'Professional cleaning, hospitality and apartment turnover',
  'business.portfolio.jservice.desc': 'Mobile-first showcase site with clean brand identity and operational tone. Service pages, service areas and FAQs designed to convert qualified leads.',
  'business.portfolio.jservice.highlights': 'Mobile-first layout with basic on-page SEO\nService and service-area sections optimized for local search\nThematic FAQs to reduce lead friction\nTone of voice aligned with company positioning',
  'business.faq.1.q': 'Is Halomora only cleaning business software?',
  'business.faq.1.a': 'No. It\'s a marketplace that brings clients, plus a free online storefront and tools to manage bookings, calendar and payments.',
  'business.faq.2.q': 'How much does it cost to join?',
  'business.faq.2.a': 'Registration is free. There is no monthly subscription. Commission from 5% applies only to orders received through Halomora.',
  'business.faq.3.q': 'Are clients guaranteed?',
  'business.faq.3.a': 'No. It depends on area, seasonality and profile quality. Halomora increases visibility and organization, it does not promise fixed revenue.',
  'business.faq.4.q': 'How long does activation take?',
  'business.faq.4.a': 'About 5–15 minutes for profile and services. Payment activation requires a few additional steps.',
  'business.faq.5.q': 'Can I have a website on my own domain?',
  'business.faq.5.a': 'Yes, as an optional quoted service. The marketplace profile remains free.',
  'business.jsonld.faq.1.q': 'Is Halomora only cleaning business software?',
  'business.jsonld.faq.1.a': 'No. It\'s a marketplace that brings clients, plus a free online storefront and tools to manage bookings, calendar and payments.',
  'business.jsonld.faq.2.q': 'How much does it cost to join?',
  'business.jsonld.faq.2.a': 'Registration is free. There is no monthly subscription. Commission from 5% applies only to orders received through Halomora.',
  'business.jsonld.faq.3.q': 'Are clients guaranteed?',
  'business.jsonld.faq.3.a': 'No. It depends on area, seasonality and profile quality. Halomora increases visibility and organization, it does not promise fixed revenue.',
  'business.jsonld.org.desc': 'Marketplace and platform for cleaning businesses: more clients, online storefront and booking management with no fixed costs.',
  'business.jsonld.service.type': 'Marketplace for cleaning businesses',
  'business.jsonld.offer.free.name': 'Free profile',
  'business.jsonld.offer.free.desc': 'Company profile in the marketplace, cleaning booking management. Commission from 5% only on received orders.',
  'profile.subtitle': 'Manage your account settings and preferences',
  'profile.back_to_dashboard': 'Back to Dashboard',
  'profile.my_account': 'My Account',
  'profile.upcoming': 'Upcoming',
  'profile.favourites': 'Favorites',
  'profile.total_spent': 'Total Spent',
  'profile.orders': 'orders',
  'profile.reschedule_booking': 'Reschedule Booking',
  'profile.new_date': 'New Date',
  'profile.new_time': 'New Time',
  'profile.reason': 'Reason',
  'profile.cancel': 'Cancel',
  'profile.save': 'Save',
  'profile.cancel_booking': 'Cancel Booking',
  'profile.cancel_policy_notice': 'Cancelling within 48 hours may reduce your refund: the vendor and platform may retain fees per policy.',
  'profile.cost_breakdown': 'Cost breakdown',
  'profile.total_paid': 'Total paid',
  'profile.vendor_cancel_fee': 'Customer fee component',
  'profile.platform_fee': 'Platform fee (Halomora)',
  'profile.estimated_refund': 'Estimated refund',
  'profile.ack_fee_retention': 'I confirm that I understand the platform and vendor may retain fees per policy.',
  'profile.contact_vendor': 'Contact vendor',
  'profile.call_vendor': 'Call',
  'profile.back': 'Back',
  'profile.confirm_cancel': 'Confirm cancellation',
  'profile.vendor_can_reschedule': 'Tip: try contacting the vendor for a free reschedule if agreed.',
  'profile.tab.billing': 'Billing',
  'profile.my_quote_requests': 'My Quote Requests',
  'profile.no_quotes_yet': 'No quotes yet.',
  'profile.awaiting_quote': 'Awaiting quote',
  'profile.requested_on': 'Requested on',
  'profile.accept': 'Accept',
  'profile.reject': 'Reject',
  'profile.filter_bookings': 'Filter Bookings',
  'profile.my_bookings': 'My Bookings ({{count}})',
  'profile.download_statement': 'Download statement',
  'profile.loading': 'Loading…',
  'profile.no_bookings_yet': 'No bookings yet.',
  'profile.no_bookings_match': 'No bookings match your filters.',
  'profile.details': 'Details',
  'profile.leave_review': 'Leave a review',
  'profile.reschedule': 'Reschedule',
  'profile.cancel_action': 'Cancel',
  'profile.pay_now': 'Pay now',
  'profile.fallback.service': 'Service',
  'profile.fallback.vendor': 'Vendor',
  'profile.confirm_quote': 'Confirm Quote',
  'profile.confirm_booking': 'Confirm Booking',
  'profile.quote_confirm_hint': 'Selecting a date/time confirms the booking at the quoted price.',
  'profile.personal_info': 'Personal Information',
  'profile.first_name': 'First name',
  'profile.last_name': 'Last name',
  'profile.nickname': 'Nickname',
  'profile.email': 'Email',
  'profile.phone': 'Phone',
  'profile.bio': 'Bio',
  'profile.website': 'Website',
  'profile.save_changes': 'Save changes',
  'profile.addresses_title': 'Saved Addresses',
  'profile.add_address': 'Add address',
  'profile.default': 'Default',
  'profile.set_default': 'Set as default',
  'profile.edit': 'Edit',
  'profile.remove': 'Remove',
  'profile.notifications_title': 'Notification preferences',
  'profile.email_notifications': 'Email notifications',
  'profile.sms_notifications': 'SMS notifications',
  'profile.push_notifications': 'Push notifications',
  'profile.loyalty_title': 'Loyalty & benefits',
  'profile.security_title': 'Security',
  'profile.change_password': 'Change password',
  'profile.two_factor': 'Two-factor authentication',
  'profile.enable_2fa': 'Enable 2FA',
  'profile.disable_2fa': 'Disable 2FA',
  'profile.export_data': 'Export my data',
  'profile.delete_account': 'Delete account',
  'profile.seo.title': 'My Profile | Halomora',
  'profile.toast.sign_in_required': 'Sign in required',
  'profile.toast.sign_in_update': 'Please sign in to update your profile.',
  'profile.toast.sign_in_addresses': 'Please sign in to save addresses.',
  'profile.toast.profile_missing': 'Profile missing',
  'profile.toast.profile_missing_desc': 'We could not find your profile.',
  'profile.toast.profile_updated': 'Profile updated',
  'profile.toast.profile_updated_desc': 'Your profile information has been saved successfully.',
  'profile.toast.error': 'Error',
  'profile.toast.address_added': 'Address added',
  'profile.toast.address_added_desc': 'New address has been added successfully.',
  'profile.toast.address_updated': 'Address updated',
  'profile.toast.address_updated_desc': 'Your address has been updated.',
  'profile.toast.address_removed': 'Address removed',
  'profile.toast.address_removed_desc': 'Address has been removed successfully.',
  'profile.toast.default_updated': 'Default updated',
  'profile.toast.default_updated_desc': 'This address is now your default.',
  'profile.toast.payment_added': 'Payment method added',
  'profile.toast.payment_removed': 'Payment method removed',
  'profile.toast.notifications_updated': 'Notification settings updated',
  'profile.toast.export_ready': 'Export ready',
  'profile.toast.export_ready_desc': 'Your data was downloaded.',
  'profile.toast.account_deletion': 'Account deletion requested',
  'profile.toast.review_sent': 'Review submitted',
  'profile.toast.review_sent_desc': 'Thank you for your feedback!',
  'profile.toast.review_exists': 'Already reviewed',
  'profile.toast.rescheduled': 'Rescheduled',
  'profile.toast.cancelled': 'Cancelled',
  'profile.toast.booking_created': 'Booking created',
  'profile.toast.booking_created_desc': 'Your booking has been confirmed at the quoted price.',
  'profile.toast.preferences_updated': 'Preferences updated',
  'profile.toast.consent_updated': 'Consent updated',
  'profile.toast.mfa_enabled': '2FA enabled',
  'profile.toast.mfa_enabled_desc': 'Two-factor authentication is now active.',
  'profile.toast.mfa_disabled': '2FA disabled',
  'profile.toast.email_sent': 'Email sent',
  'profile.toast.email_sent_desc': 'Check your inbox to reset your password.',
  'profile.toast.rate_limit': 'Too many attempts',
  'profile.toast.rate_limit_reset': 'You requested too many resets in a short time. Please try again in a few minutes.',
  'profile.validation.first_name': 'First name is required',
  'profile.validation.last_name': 'Last name is required',
  'profile.validation.email': 'Invalid email address',
  'profile.validation.phone': 'Phone number must be at least 10 digits',
  'profile.validation.label': 'Label is required',
  'profile.validation.address': 'Address is required',
  'profile.validation.city': 'City is required',
  'profile.validation.state': 'State is required',
  'profile.validation.postal': 'Postal code is required',
  'profile.validation.country': 'Country is required',
  'profile.review.title': 'Leave a review',
  'profile.review.rating': 'Rating',
  'profile.review.comment_optional': 'Comment (optional)',
  'profile.review.placeholder': 'How did it go? What did you like?',
  'profile.review.submit': 'Submit review',
  'profile.review.submitting': 'Sending…',
  'profile.download_receipt': 'Download receipt',
  'profile.mfa.starting': 'Starting…',
  'profile.mfa.start_setup': 'Start setup',
  'profile.mfa.verifying': 'Verifying…',
  'profile.mfa.verify_enable': 'Verify & enable',
  'profile.mfa.disabling': 'Disabling…',
  'profile.mfa.disable': 'Disable 2FA',
  'profile.mfa.load_failed': 'Failed to load 2FA status',
  'profile.mfa.setup_failed': 'Failed to start 2FA setup',
  'profile.mfa.invalid_code': 'Invalid code',
  'profile.mfa.disable_failed': 'Failed to disable 2FA',
  'profile.toast.update_failed': 'Failed to update profile.',
  'profile.toast.add_address_failed': 'Failed to add address',
  'profile.toast.set_default_failed': 'Failed to set default',
  'profile.toast.update_address_failed': 'Failed to update address',
  'profile.toast.remove_address_failed': 'Failed to remove address',
  'profile.toast.export_failed': 'Failed to export data',
  'profile.toast.delete_failed': 'Failed to delete account',
  'profile.toast.account_deletion_desc': 'Your account has been anonymized and marked deleted.',
  'profile.toast.payment_added_desc': 'New payment method has been added successfully.',
  'profile.toast.payment_removed_desc': 'Payment method has been removed successfully.',
  'profile.toast.notifications_enabled': '{{type}} enabled.',
  'profile.toast.notifications_disabled': '{{type}} disabled.',
  'profile.validation.card_number': 'Card number must be 16 digits',
  'profile.validation.cardholder': 'Cardholder name is required',
  'profile.validation.expiry_month': 'Expiry month is required',
  'profile.validation.expiry_year': 'Expiry year is required',
  'profile.validation.cvv': 'CVV must be at least 3 digits',
  'profile.toast.mfa_disabled_title': '2FA disabled',
  'profile.toast.login_required': 'Login required',
  'profile.toast.login_required_desc': 'Please log in again and retry.',
  'profile.toast.invalid_rating': 'Invalid rating',
  'profile.toast.invalid_rating_desc': 'Please select a rating from 1 to 5.',
  'profile.toast.missing_company': 'Missing company',
  'profile.toast.missing_company_desc': 'This booking is missing company_id.',
  'profile.toast.review_not_allowed': 'Not allowed',
  'profile.toast.review_not_allowed_desc': 'You can only review completed bookings on your account.',
  'profile.toast.review_failed': 'Unable to submit review',
  'profile.toast.payment_unavailable': 'Payment unavailable',
  'profile.toast.payment_unavailable_desc': 'No payable amount for this booking.',
  'profile.toast.payment_error': 'Payment error',
  'profile.toast.payment_error_desc': 'Unable to start checkout',
  'profile.toast.missing_fields': 'Missing fields',
  'profile.toast.missing_fields_reschedule': 'Date, time and reason are required',
  'profile.toast.blocked': 'Blocked',
  'profile.toast.blocked_reschedule': 'You cannot reschedule within 48 hours of the appointment.',
  'profile.toast.reschedule_failed': 'Failed to reschedule',
  'profile.toast.reason_required': 'Reason required',
  'profile.toast.reason_required_desc': 'Please provide a reason to cancel',
  'profile.toast.cancelled_title': 'Booking cancelled',
  'profile.toast.cancel_failed': 'Failed to cancel',
  'profile.toast.update_failed_generic': 'Unable to update',
  'profile.toast.quote_accept_failed': 'Failed to accept quote',
  'profile.toast.pick_date_time': 'Pick date and time',
  'profile.toast.review_exists_desc': 'You already reviewed this booking.',
  'profile.nickname_optional': 'Nickname (optional)',
  'profile.email_address': 'Email address',
  'profile.phone_number': 'Phone number',
  'profile.notifications_privacy_title': 'Communications & privacy',
  'profile.service_comms_title': 'Service communication preferences',
  'profile.service_comms_desc': 'This choice is saved on your profile to limit communications to what is essential. Important updates about bookings, changes or support may still reach you when needed.',
  'profile.marketing_consent': 'Marketing consent',
  'profile.consent_history': 'Consent history',
  'profile.terms_accepted': 'Terms accepted',
  'profile.privacy_accepted': 'Privacy accepted',
  'profile.consent_date': 'Consent date',
  'profile.not_available': 'n/a',
  'profile.update_to_latest': 'Update to current text',
  'profile.loyalty_card_title': 'Halomora discounts & benefits',
  'profile.loyalty_coming_soon': 'A section designed to become useful soon',
  'profile.loyalty.discount_codes': 'Discount codes',
  'profile.loyalty.no_codes': 'No active codes',
  'profile.loyalty.promo_credits': 'Promotional credits',
  'profile.loyalty.promo_credits_desc': 'In the future you will see credits usable on upcoming bookings.',
  'profile.loyalty.coming_soon_badge': 'Coming soon',
  'profile.loyalty.benefits': 'Loyalty benefits',
  'profile.loyalty.benefits_desc': 'Dedicated promotions, seasonal initiatives and benefits for active customers will appear here.',
  'profile.loyalty.area_ready': 'Area ready',
  'profile.field.label': 'Label',
  'profile.website_optional': 'Website (optional)',
  'profile.bio_optional': 'Bio (optional)',
  'profile.bio_placeholder': 'Tell us a bit about yourself...',
  'profile.date': 'Date',
  'profile.time': 'Time',
  'profile.add_new_address': 'Add New Address',
  'profile.add_address_dialog_desc': 'Add a new address to your profile.',
  'profile.address_line1': 'Address line 1',
  'profile.address_line2_optional': 'Address line 2 (optional)',
  'profile.city': 'City',
  'profile.state': 'State / Province',
  'profile.postal_code': 'Postal code',
  'profile.country': 'Country',
  'profile.add_address_btn': 'Add address',
  'profile.edit_address': 'Edit address',
  'profile.payment_methods_title': 'Payment methods',
  'profile.add_payment_method': 'Add payment method',
  'profile.add_payment_dialog_title': 'Add new payment method',
  'profile.add_payment_dialog_desc': 'Add a new payment method to your profile.',
  'profile.card_number': 'Card number',
  'profile.cardholder_name': 'Cardholder name',
  'profile.expiry_month': 'Expiry month',
  'profile.expiry_year': 'Expiry year',
  'profile.cvv': 'CVV',
  'profile.add_payment_btn': 'Add payment method',
  'profile.expires': 'Expires {{date}}',
  'profile.notifications_intro': 'Save your preferences here to minimize unnecessary communications. If you have an active booking or an important service update, some essential operational messages may still be sent.',
  'profile.marketing_desc': 'If enabled, Halomora may send you selected commercial communications and useful content to help you book better.',
  'profile.marketing.benefit1': 'Discount codes and exclusive offers',
  'profile.marketing.benefit2': 'Seasonal promotions and useful news',
  'profile.marketing.benefit3': 'Featured providers and services',
  'profile.marketing.benefit4': 'Dedicated communications from Halomora',
  'profile.marketing_opt_out_note': 'If you disable this, you will avoid promotional communications from Halomora, but you may miss dedicated benefits and reserved opportunities.',
  'profile.terms_accepted_label': 'Terms accepted:',
  'profile.privacy_accepted_label': 'Privacy accepted:',
  'profile.consent_date_label': 'Consent date:',
  'profile.loyalty_intro1': 'Here you will find discount codes assigned by Halomora, any promotional credits and benefits dedicated to your account.',
  'profile.loyalty_intro2': 'There are no active promotions on your profile yet, but this area will be ready to show benefits and offers clearly.',
  'profile.loyalty.coupon_desc': 'When Halomora assigns you a coupon, you will see it here with value, expiry and terms of use.',
  'profile.security.change_password_desc': 'Secure your account with a strong password.',
  'profile.security.change_password_btn': 'Change password',
  'profile.security.manage_2fa': 'Manage 2FA',
  'profile.security.enable_2fa': 'Enable 2FA',
  'profile.mfa.dialog_title': 'Two-factor authentication (TOTP)',
  'profile.mfa.dialog_desc': 'Use Google Authenticator, 1Password, or any TOTP app.',
  'profile.mfa.status_label': 'Status:',
  'profile.mfa.status_enabled': 'Enabled',
  'profile.mfa.status_disabled': 'Not enabled',
  'profile.mfa.enabled_message': '2FA is enabled for your account.',
  'profile.mfa.scan_qr': 'Scan this QR code with your authenticator app:',
  'profile.mfa.uri_hint': 'If you can\'t scan, use this URI:',
  'profile.mfa.enter_code': 'Enter the 6-digit code:',
  'profile.security.session_title': 'Session management',
  'profile.security.session_desc': 'View and manage active sessions.',
  'profile.security.manage_sessions': 'Manage sessions',
  'profile.security.active_session': 'Active session',
  'profile.security.active_session_desc': '{{email}} • since {{since}}',
  'profile.export_json': 'Export JSON',
  'profile.delete_account_btn': 'Delete account',
  'profile.toast.notification_type_enabled': '{{type}} enabled.',
  'profile.toast.notification_type_disabled': '{{type}} disabled.',
  'profile.billing.title': 'Billing details',
  'profile.billing.subtitle': 'Used to prefill invoice requests when booking. Fill them in to receive invoices without entering them every time.',
  'profile.billing.type': 'Type',
  'profile.billing.type_private': 'Private (individual)',
  'profile.billing.type_company': 'Company / VAT number',
  'profile.billing.first_name': 'First name *',
  'profile.billing.last_name': 'Last name *',
  'profile.billing.address': 'Billing address *',
  'profile.billing.tax_code': 'Tax code *',
  'profile.billing.business_name': 'Company name or full name *',
  'profile.billing.company_address': 'Registered office address *',
  'profile.billing.sdi_code': 'SDI recipient code (7 characters) *',
  'profile.billing.saving': 'Saving...',
  'profile.billing.save': 'Save billing details',
  'profile.billing.invalid': 'Invalid data',
  'profile.billing.saved': 'Saved',
  'profile.billing.saved_desc': 'Billing details have been updated.',
  'profile.billing.save_failed': 'Save failed',
  'profile.billing.placeholder_first': 'Mario',
  'profile.billing.placeholder_last': 'Rossi',
  'profile.billing.placeholder_address': 'Via Roma 1, 00100 Roma',
  'profile.billing.placeholder_tax': 'RSSMRA80A01H501Z',
  'profile.billing.placeholder_company': 'e.g. Acme Ltd',
  'profile.billing.placeholder_sdi': 'M5UXCR1',
  'profile.export_data_desc': 'Download a copy of your personal data in JSON format.',
  'profile.close': 'Close',
  'profile.rate_star': 'Rate {{n}}',
  'profile.mailto.reschedule_subject': 'Reschedule request for booking {{number}}',
  'dash.export_csv': 'Export CSV',
  'dash.export_json': 'Export JSON',
  'dash.kpi.total_spent': 'Total spend',
  'dash.kpi.total_orders': 'Total bookings',
  'dash.kpi.aov': 'Average order value',
  'dash.kpi.loyalty': 'Loyalty points',
  'dash.kpi.from_last_month': 'vs last month',
  'dash.kpi.points_hint': 'Available for rewards',
  'dash.seo.title': 'Dashboard | Halomora',
  'company_profile.loading': 'Loading...',
  'company_profile.company_not_found': 'Company not found',
  'company_profile.back_to_dashboard': 'Back to dashboard',
  'company_profile.title': 'Company profile',
  'company_profile.subtitle': 'Manage your company information and services',
  'company_profile.tab.company_info': 'Company info',
  'company_profile.tab.services': 'Services',
  'company_profile.tab.security': 'Security',
  'company_profile.export_data': 'Export data',
  'company_profile.delete_account': 'Delete account',
  'company_profile.company_information': 'Company information',
  'company_profile.update_details': 'Update the details customers will see about your company',
  'company_profile.vendor_data_consent': 'Vendor data consent',
  'company_profile.allow_aggregated_data': 'Allow use of aggregated and anonymized operational data.',
  'company_profile.customer_data_consent': 'Customer data consent',
  'company_profile.gate_exports_pii': 'Block exports with PII masking by default.',
  'company_profile.logo': 'Logo',
  'company_profile.cover_image': 'Cover image',
  'company_profile.plan_tier': 'Plan tier',
  'company_profile.plan_tier_hint': 'Managed by admin. Contact us to change your plan.',
  'company_profile.commission_rate': 'Commission rate',
  'company_profile.decimal_example': 'Decimal (e.g. 0.12 for 12%)',
  'company_profile.readonly_admin': 'Only admin can edit',
  'company_profile.effective_platform_fee': 'Effective platform fee',
  'company_profile.effective_default': 'Not set at vendor level – default values apply',
  'company_profile.company_name': 'Company name',
  'company_profile.email': 'Email',
  'company_profile.description': 'Description',
  'company_profile.address': 'Address',
  'company_profile.city': 'City',
  'company_profile.postal_code': 'Postal code',
  'company_profile.phone': 'Phone',
  'company_profile.tax_id': 'Tax ID',
  'company_profile.legal_name': 'Legal name (if different)',
  'company_profile.vat_number': 'VAT number',
  'company_profile.sdi_code': 'SDI code',
  'company_profile.pec_email': 'PEC email',
  'company_profile.website_optional': 'Website (optional)',
  'company_profile.website_url': 'Website URL',
  'company_profile.facebook': 'Facebook',
  'company_profile.linkedin': 'LinkedIn',
  'company_profile.instagram': 'Instagram',
  'company_profile.whatsapp': 'WhatsApp',
  'company_profile.update_company_btn': 'Update company information',
  'company_profile.placeholder.legal_name': 'e.g. ACME LTD',
  'company_profile.placeholder.vat': 'ITxxxxxxxxxxx',
  'company_profile.placeholder.sdi': '7 characters',
  'company_profile.placeholder.pec': 'name@pec.it',
  'company_profile.services.title': 'Your services',
  'company_profile.services.subtitle': 'Activate, deactivate or delete services. To edit pricing, rules or booking modes, open the service builder on the dashboard.',
  'company_profile.services.create_new': 'Create new service',
  'company_profile.services.empty_title': 'No services yet',
  'company_profile.services.empty_help': 'Add your first service from the builder on the dashboard.',
  'company_profile.services.status_active': 'Active',
  'company_profile.services.status_inactive': 'Inactive',
  'company_profile.services.deactivate': 'Deactivate',
  'company_profile.services.activate': 'Activate',
  'company_profile.services.edit': 'Edit',
  'company_profile.services.delete': 'Delete',
  'company_profile.security.title': 'Security',
  'company_profile.security.desc': 'Manage 2FA and password for the account that controls this company.',
  'company_profile.security.password': 'Change password',
  'company_profile.security.password_desc': 'We will email you a link to reset your password.',
  'company_profile.security.password_btn': 'Change password',
  'company_profile.security.2fa': 'Two-factor authentication',
  'company_profile.security.2fa_desc': 'Add an extra layer of security with an authenticator app.',
  'company_profile.toast.verification_required': 'Verification required',
  'company_profile.toast.verification_required_desc': 'To continue, confirm with your 2FA code.',
  'company_profile.toast.error': 'Error',
  'company_profile.toast.export_ready': 'Export ready',
  'company_profile.toast.export_ready_desc': 'JSON downloaded.',
  'company_profile.toast.export_failed': 'Export failed',
  'company_profile.toast.account_deleted': 'Account deleted',
  'company_profile.toast.account_deleted_desc': 'Your account has been anonymized.',
  'company_profile.toast.delete_failed': 'Delete failed',
  'company_profile.toast.updated': 'Company updated',
  'company_profile.toast.updated_desc': 'Company information updated successfully.',
  'company_profile.toast.image_uploaded': 'Image uploaded',
  'company_profile.toast.logo_updated': 'Logo updated successfully.',
  'company_profile.toast.cover_updated': 'Cover updated successfully.',
  'company_profile.toast.upload_failed': 'Upload failed',
  'company_profile.toast.service_deleted': 'Service deleted',
  'company_profile.toast.service_deleted_desc': 'Service deleted successfully.',
  'company_profile.toast.service_toggled': 'Service updated',
  'company_profile.toast.service_activated': 'Service activated successfully.',
  'company_profile.toast.service_deactivated': 'Service deactivated successfully.',
  'company_profile.toast.saved': 'Saved',
  'company_profile.toast.save_failed': 'Save failed',
  'company_profile.toast.email_sent': 'Email sent',
  'company_profile.toast.email_sent_desc': 'Check your inbox to reset your password.',
  'company_profile.validation.company_name': 'Company name is required',
  'company_profile.validation.description': 'Description must be at least 10 characters',
  'company_profile.validation.address': 'Address is required',
  'company_profile.validation.city': 'City is required',
  'company_profile.validation.postal_code': 'Postal code is required',
  'company_profile.validation.phone': 'Phone number is required',
  'company_profile.validation.email': 'Valid email is required',
  'company_profile.validation.pec_email': 'Invalid email',
  'company_profile.seo.title': 'Company profile | Halomora',
  'vendor.welcome': 'Welcome',
  'vendor.manage': 'Manage bookings and track performance',
  'vendor.settings': 'Settings',
  'vendor.add_service': 'Add service',
  'vendor.google.reconnect_title': 'Reconnect Google Calendar',
  'vendor.google.reconnect_desc': 'Your Google Calendar connection has expired. Reconnect to keep your bookings in sync.',
  'vendor.google.reconnect': 'Reconnect Google Calendar',
  'vendor.kpi.total_earnings': 'Total earnings',
  'vendor.kpi.total_due_halomora': 'Balance due to Halomora',
  'vendor.kpi.pending_settle': 'To settle (cash)',
  'vendor.kpi.commission_invoices': 'Commission on invoice bookings',
  'vendor.kpi.no_pending': 'No outstanding amount',
  'vendor.kpi.from_completed': 'From {{count}} completed bookings',
  'vendor.kpi.completed_short': '{{count}} completed',
  'vendor.kpi.total_bookings': 'Total bookings',
  'vendor.kpi.avg_rating': 'Average rating',
  'vendor.kpi.from_reviews': 'From {{count}} reviews',
  'vendor.kpi.settle_balance': 'Settle balance',
  'vendor.tabs.recurring': 'Recurring',
  'vendor.tabs.invoices': 'Invoices & payments',
  'vendor.no_bookings': 'No bookings yet',
  'vendor.no_bookings_desc': 'Bookings will appear here as soon as customers start booking your services.',
  'vendor.fees.platform': 'Platform fee (Halomora)',
  'vendor.fees.customer': 'Customer fee component',
  'vendor.fees.processor': 'Payment processing costs',
  'vendor.fees.payout': 'Estimated vendor net',
  'vendor.fees.incl_fee': 'incl. {{amount}} fee',
  'vendor.bookings.recent_title': 'Recent bookings',
  'vendor.bookings.recent_desc': 'Manage your upcoming and recent service bookings',
  'vendor.bookings.recurring_badge': 'Recurring',
  'vendor.dashboard.loading': 'Loading...',
  'vendor.dashboard.not_found': 'Company not found',
  'vendor.dashboard.need_help': 'Need help?',
  'vendor.dashboard.download_statement': 'Download statement',
  'vendor.dashboard.export_failed': 'Export failed',
  'vendor.dashboard.payments_blocked_title': 'Payments temporarily blocked',
  'vendor.dashboard.payments_blocked_desc': 'Your account is temporarily on hold due to a high dispute rate in the last 30 days ({{rate}}%). Resolve disputes to re-enable payments.',
  'vendor.dashboard.stripe_required_title': 'Stripe onboarding required',
  'vendor.dashboard.stripe_required_desc': 'Connect Stripe to enable card payments and payouts only when the account is truly READY. Open requirements: {{reqs}}',
  'vendor.dashboard.connect_stripe': 'Connect Stripe',
  'vendor.dashboard.refresh_status': 'Refresh status',
  'vendor.dashboard.stripe_onboarding': 'Stripe onboarding',
  'vendor.dashboard.stripe_dashboard': 'Stripe dashboard',
  'vendor.dashboard.payout_terms_title': 'Payment & payout acceptance',
  'vendor.dashboard.payout_terms_1': 'I accept that Halomora may collect from the customer on my behalf via Stripe Connect and retain applicable fees before payout.',
  'vendor.dashboard.payout_terms_2': 'I accept that tax obligations, service invoicing, KYC and payout bank account remain my responsibility.',
  'vendor.dashboard.payout_terms_3': 'I accept that chargebacks, refunds and disputes may reduce or delay payouts.',
  'vendor.dashboard.payout_terms_4_prefix': 'I have read and accept the',
  'vendor.dashboard.vendor_agreement': 'Vendor Agreement',
  'vendor.dashboard.save_failed': 'Save failed',
  'vendor.dashboard.seo.title': 'Company dashboard | Halomora',
  'vendor.toast.session_unavailable': 'Session unavailable',
  'vendor.toast.session_relogin': 'Sign out and sign in again, then retry.',
  'vendor.toast.stripe': 'Stripe',
  'vendor.toast.error': 'Error',
  'vendor.toast.status_updated': 'Status updated',
  'vendor.toast.reason_required': 'Reason required',
  'vendor.toast.cancel_reason': 'Enter a reason for cancellation.',
  'vendor.toast.reschedule_reason': 'Enter a reason for rescheduling.',
  'vendor.toast.cancelled': 'Cancelled',
  'vendor.toast.cancel_failed': 'Could not cancel',
  'vendor.toast.rescheduled': 'Rescheduled',
  'vendor.toast.balance': 'Balance',
  'vendor.toast.balance_amount': 'Amount to settle: {{amount}}',
  'vendor.toast.no_balance': 'No amount to settle',
  'vendor.toast.settle_failed': 'Settlement failed',
  'vendor.toast.verification_required': 'Verification required',
  'vendor.toast.verification_2fa': 'To continue, confirm with your 2FA code.',
  'vendor.toast.calendar_connected': 'Calendar connected',
  'vendor.toast.calendar_failed': 'Calendar connection failed',
  'vendor.toast.field_set': '{{field}} set',
  'vendor.toast.timestamp_failed': 'Failed to update timestamp',
  'vendor.toast.incident_reported': 'Incident reported',
  'vendor.toast.incident_failed': 'Failed to report incident',
  'vendor.toast.incident_type_missing': 'Incident type missing',
  'vendor.toast.incident_seed': 'Please seed incident_types with this code',
  'vendor.services.back_to_profile': 'Back to profile',
  'vendor.services.existing_title': 'Your services',
  'vendor.services.existing_desc': 'Edit an existing service to update pricing, rules and booking mode settings (SLA, urgent, lead time).',
  'vendor.services.updated_desc': 'Changes (including booking mode) have been saved.',
  'vendor.services.none': 'No services yet.',
  'vendor.services.cancel_edit': 'Cancel edit',
  'vendor.services.edit': 'Edit',
  'vendor.services.editing_label': 'Editing service',
  'vendor.services.updated_title': 'Service updated',
  'vendor.services.update_failed': 'Update failed',
  'vendor.services.create_new': 'Create a new service',
  'vendor.services.created_title': 'Service created',
  'vendor.services.created_desc': 'New service has been added successfully.',
  'vendor.services.create_failed': 'Create failed',
  'vendor.offers.title': 'Seasonal offers',
  'vendor.offers.desc': 'Remove offers you no longer want to show',
  'vendor.offers.none': 'No seasonal offers yet.',
  'vendor.offers.status_active': 'Active',
  'vendor.offers.status_inactive': 'Inactive',
  'vendor.offers.delete_confirm': 'Delete this offer?',
  'vendor.offers.load_failed': 'Load failed',
  'vendor.offers.load_failed_desc': 'Could not load offers',
  'vendor.offers.delete_failed': 'Delete failed',
  'vendor.offers.published_title': 'Offer published',
  'vendor.offers.published_desc': 'Your seasonal offer is live',
  'vendor.pricing.rule_saved': 'Pricing rule saved',
  'vendor.pricing.rule_saved_desc': 'Pricing rule has been saved successfully',
  'vendor.pricing.estimate_title': 'Estimate generated',
  'vendor.pricing.estimate_desc': 'Price range: {{min}} - {{max}}',
  'vendor.analytics.marketing': 'Marketing analytics',
  'vendor.analytics.advanced': 'Advanced analytics',
  'vendor.analytics.coming_soon_title': 'Advanced analytics',
  'vendor.analytics.coming_soon_desc': 'Advanced metrics, AI insights and custom reports will be available soon. We are finalizing the release.',
  'vendor.analytics.pro_title': 'Advanced analytics',
  'vendor.analytics.pro_desc': 'Unlock detailed insights, advanced metrics and AI-powered recommendations with the PRO plan to optimize your business.',
  'vendor.ops.close': 'Close',
  'vendor.ops.booking': 'Booking',
  'vendor.ops.delete_photo_confirm': 'Are you sure you want to delete this photo?',
  'vendor.ops.photo_deleted': 'Photo deleted',
  'vendor.ops.delete_failed': 'Delete failed',
  'vendor.ops.delete_failed_desc': 'Error while deleting',
  'vendor.toast.session_expired': 'Session expired or invalid. Sign out and sign in again, then retry.',
  'vendor.toast.stripe_onboard_failed': 'Could not start Stripe onboarding',
  'vendor.toast.stripe_dashboard_failed': 'Could not open Stripe dashboard',
  'vendor.toast.stripe_onboard_link_unavailable': 'Onboarding link unavailable',
  'vendor.toast.stripe_dashboard_link_unavailable': 'Dashboard link unavailable',
  'vendor.toast.api_mode': 'API mode: {{mode}}',
  'vendor.toast.photo_uploaded': 'Photo uploaded',
  'vendor.toast.upload_failed': 'Upload failed',
  'vendor.toast.metrics_saved': 'Metrics saved',
  'vendor.toast.metrics_save_failed': 'Failed to save metrics',
  'vendor.toast.portal_open_failed': 'Could not open portal',
  'vendor.toast.checkout_start_failed': 'Could not start checkout',
  'vendor.toast.checkout_unavailable': 'Checkout unavailable',
  'vendor.toast.admin_plan_title': 'Plan managed by admin',
  'vendor.toast.stripe_portal_title': 'Stripe portal',
  'vendor.toast.missing_data': 'Missing data',
  'vendor.toast.upgrade_pro_title': 'Upgrade to PRO',
  'vendor.toast.upgrade_pro_desc': 'Contact support to upgrade to the PRO plan',
  'vendor.toast.contact_support_title': 'Contact support',
  'vendor.toast.contact_support_desc': 'Reach out to our team for more information',
  'vendor.toast.photos_uploaded': 'Photos uploaded',
  'vendor.b2b.title': 'My plan',
  'vendor.b2b.desc': 'PRO, SCALE or custom ULTRA plan',
  'vendor.b2b.plan_label': 'Plan {{plan}}',
  'vendor.b2b.active': 'Active',
  'vendor.b2b.until': 'until: {{date}}',
  'vendor.b2b.renew': 'Renews: {{date}}',
  'vendor.b2b.manage': 'Manage subscription',
  'vendor.b2b.admin_assigned': 'Plan assigned by administration. Contact support for changes.',
  'vendor.b2b.no_plan': 'No paid plan active. Subscribe to PRO or SCALE for Google Ads, analytics and dedicated support.',
  'vendor.b2b.subscribe_pro': 'Subscribe to PRO (€99/month)',
  'vendor.b2b.subscribe_scale': 'Subscribe to SCALE (€299/month)',
  'vendor.b2b.upgrade_scale': 'Upgrade to SCALE (€299/month)',
  'vendor.b2b.ultra_quote': 'ULTRA on quote →',
  'vendor.b2b.checkout_scale_hint': 'If you already have a Stripe subscription, try the portal or contact support to switch to SCALE.',
  'vendor.drawer.reschedule_title': 'Reschedule booking',
  'vendor.drawer.reschedule_desc': 'Provide a reason and confirm the new date/time.',
  'vendor.drawer.new_date': 'New date',
  'vendor.drawer.start_time': 'Start time',
  'vendor.drawer.reschedule_reason': 'Reschedule reason',
  'vendor.drawer.cancel_title': 'Cancel booking',
  'vendor.drawer.cancel_desc': 'Provide a cancellation reason. Before confirming, review the estimated refund per policy.',
  'vendor.drawer.refund_estimate': 'Estimated customer refund',
  'vendor.drawer.within_48h': 'Within 48h',
  'vendor.drawer.over_48h': 'Over 48h',
  'vendor.drawer.total': 'Total',
  'vendor.drawer.fee_retained': 'Fee retained',
  'vendor.drawer.refund_estimated': 'Estimated refund',
  'vendor.drawer.hours_until': 'About {{hours}}h until service start.',
  'vendor.drawer.cancel_reason': 'Cancellation reason',
  'vendor.drawer.reason_required_ph': 'Reason (required)',
  'vendor.drawer.confirm': 'Confirm',
  'vendor.drawer.confirm_cancel': 'Confirm cancellation',
  'vendor.drawer.cancel_btn': 'Cancel',
  'vendor.analytics.pro_feature_1': 'Real-time advanced analytics',
  'vendor.analytics.pro_feature_2': 'AI insights and recommendations',
  'vendor.analytics.pro_feature_3': 'Advanced customer segmentation',
  'vendor.analytics.pro_feature_4': 'Geographic and time analysis',
  'vendor.analytics.pro_feature_5': 'Custom reports',
  'vendor.analytics.pro_plan': 'PRO plan',
  'vendor.analytics.upgrade_btn': 'Upgrade to PRO',
  'vendor.analytics.contact_btn': 'Contact support',
  'vendor.ops.timestamps': 'Timestamps',
  'vendor.ops.assigned': 'Assigned',
  'vendor.ops.depart': 'Depart',
  'vendor.ops.arrive': 'Arrive',
  'vendor.ops.start_at': 'Start',
  'vendor.ops.finish': 'Finish',
  'vendor.ops.metrics': 'Metrics',
  'vendor.ops.labor_est': 'Labor est (min)',
  'vendor.ops.labor_actual': 'Labor actual (min)',
  'vendor.ops.travel': 'Travel (min)',
  'vendor.ops.materials': 'Materials (€)',
  'vendor.ops.save': 'Save',
  'vendor.ops.checklist': 'Checklist',
  'vendor.ops.refresh': 'Refresh',
  'vendor.ops.item': 'Item',
  'vendor.ops.required': 'Required',
  'vendor.ops.add_item': 'Add item',
  'vendor.ops.required_tag': '(required)',
  'vendor.ops.no_items': 'No items yet.',
  'vendor.ops.incident': 'Incident',
  'vendor.ops.incident_placeholder': 'Select incident type...',
  'vendor.ops.incident_details': 'Additional details (optional)',
  'vendor.ops.report_incident': 'Report incident',
  'vendor.ops.photo': 'Photo',
  'vendor.ops.upload_photo': 'Upload photo',
  'vendor.ops.loading': 'Loading…',
  'vendor.ops.no_preview': 'No preview',
  'vendor.ops.no_photos': 'No photos yet.',
  'vendor.ops.delete_photo_title': 'Delete photo',
  'vendor.ops.photo_type': 'Photo type',
  'vendor.ops.select_files': 'Select file(s)',
  'vendor.ops.files_selected': '{{count}} file(s) selected',
  'vendor.ops.uploading': 'Uploading…',
  'vendor.ops.upload': 'Upload',
  'vendor.ops.photo_prompt': 'Photo type: pre | post | evidence',
  'vendor.inbox.title': 'Booking inbox',
  'vendor.inbox.immediate': 'Immediate',
  'vendor.inbox.request': 'Request',
  'vendor.inbox.sla_expired': 'SLA expired — handle or wait for timeout',
  'vendor.inbox.sla_remaining': '{{time}} left',
  'vendor.inbox.filter_pending': 'to approve (vendor)',
  'vendor.inbox.filter_urgent': 'urgent only',
  'vendor.inbox.filter_confirmed': 'confirmed',
  'vendor.inbox.empty': 'No bookings in this view.',
  'vendor.inbox.total': 'Total:',
  'vendor.inbox.accept': 'Accept',
  'vendor.inbox.reject': 'Reject',
  'vendor.inbox.view': 'View',
  'vendor.inbox.tab_action': 'Action required',
  'vendor.inbox.tab_urgent': 'Urgent',
  'vendor.inbox.tab_confirmed': 'Confirmed',
  'vendor.inbox.tab_all': 'All',
  'vendor.common.delete': 'Delete',
  'vendor.toast.load_failed': 'Failed to load data',
  'vendor.toast.calendar_refreshed': 'Calendar status refreshed',
  'vendor.toast.calendar_active': 'Google Calendar is connected and active',
  'vendor.toast.calendar_reconnect': 'Google Calendar needs reconnection',
  'vendor.toast.calendar_refresh_failed': 'Failed to refresh calendar status',
  'vendor.toast.checklist_added': 'Checklist item added',
  'vendor.toast.checklist_failed': 'Failed to add checklist item',
  'vendor.toast.not_signed_in': 'Not signed in',
  'vendor.toast.settle_api_failed': 'Settlement failed',
  'vendor.notify.rescheduled_title': 'Booking rescheduled',
  'vendor.notify.rescheduled_body': 'Your booking was moved to {{date}} {{time}}',
  'vendor.availability.saved_title': 'Availability saved',
  'vendor.availability.saved_desc': 'Your availability has been updated',
  'vendor.quotes.sent_title': 'Quote sent',
  'vendor.quotes.sent_desc': 'Quote has been sent successfully',
  'vendor.quotes.status_updated': 'Status updated',
  'vendor.quotes.status_changed_desc': 'Quote request status changed to {{status}}',
  'vendor.inbox.urgent_badge': 'Urgent',
  'vendor.inbox.sla_vendor_response': 'Vendor response: ~{{mins}} min left · due {{deadline}}',
  'vendor.inbox.filter_title': 'Booking filters',
  'vendor.inbox.filter_desc': 'Filter and sort your booking requests',
  'vendor.inbox.bookings_title': 'Bookings',
  'vendor.inbox.view_label': 'View:',
  'vendor.inbox.tab_pending_short': 'To approve',
  'vendor.inbox.filter_all': 'all',
  'vendor.inbox.details': 'Details',
  'vendor.invoices.completed_title': 'Completed jobs with invoice request',
  'vendor.invoices.completed_desc': 'List of completed services that requested an invoice. Export to CSV for your billing systems.',
  'vendor.invoices.completed_empty': 'No completed jobs with invoice request.',
  'vendor.invoices.bookings_count': '{{count}} bookings',
  'vendor.invoices.export_csv': 'Export CSV',
  'vendor.invoices.export_done': 'Export complete',
  'vendor.invoices.export_done_desc': 'CSV file downloaded.',
  'vendor.invoices.col_date': 'Date',
  'vendor.invoices.col_customer': 'Customer',
  'vendor.invoices.col_service': 'Service',
  'vendor.invoices.col_amount': 'Amount',
  'vendor.invoices.showing_first': 'Showing first 20. Use Export CSV for the full list.',
  'vendor.invoices.unpaid_title': 'Payments not yet received',
  'vendor.invoices.unpaid_desc': 'Completed bookings (cash or invoice) where you have not marked payment as received.',
  'vendor.invoices.unpaid_empty': 'No bookings awaiting payment.',
  'vendor.invoices.mark_paid': 'Mark as paid',
  'vendor.invoices.marked_paid': 'Marked as paid',
  'vendor.invoices.payment_invoice': 'Invoice',
  'vendor.invoices.payment_cash': 'Cash',
  'vendor.invoices.to_emit_title': 'Invoices to issue',
  'vendor.invoices.to_emit_desc': 'Bookings with invoice request where you have not marked issuance yet. Filter by customer and period.',
  'vendor.invoices.date_from': 'From date',
  'vendor.invoices.date_to': 'To date',
  'vendor.invoices.customer_search': 'Customer (email/name)',
  'vendor.invoices.search_ph': 'Search customer',
  'vendor.invoices.to_emit_empty': 'No invoices to issue with selected filters.',
  'vendor.invoices.mark_emitted': 'Mark invoice issued',
  'vendor.invoices.marked_emitted': 'Invoice marked as issued',
  'vendor.invoices.op_failed': 'Operation failed',
  'availability.not_signed_in': 'Not signed in',
  'availability.sign_in_to_save': 'Sign in to save availability',
  'availability.no_company': 'No company found',
  'availability.complete_onboarding': 'Complete onboarding first',
  'availability.save_failed': 'Save failed',
  'availability.saved': 'Availability saved',
  'availability.changes_live': 'Your changes are live',
  'availability.title': 'Availability (next 2 weeks)',
  'availability.description': 'Set how many jobs you can accept per time slot. You don\'t need every employee shift — only the real capacity you want to sell on Halomora.',
  'availability.capacity_jobs': 'Jobs you can accept',
  'availability.blocked_slot': 'Close slot',
  'availability.save': 'Save availability',
  'availability.how_capacity_works': 'How capacity works on Halomora',
  'availability.capacity_intro_1': 'Capacity does not mean "how many employees you have". It means how many jobs you can accept well in that time slot.',
  'availability.capacity_intro_2': 'Think: how many teams are actually available, useful hours, and how many jobs they can complete without struggling.',
  'availability.capacity_rule': 'Rule of thumb: publish conservative capacity and deliver well, rather than accept too much and struggle.',
  'availability.mode_simple': 'Simple mode',
  'availability.mode_advanced': 'Full detail',
  'availability.assisted_title': '0. Assisted capacity calculation (optional)',
  'availability.assisted_desc': 'To start from a reasoned base, enter how many teams you usually have, jobs per team, and safety margin.',
  'availability.teams_available': 'Teams usually available',
  'availability.jobs_per_team': 'Jobs one team completes well',
  'availability.avg_yield': 'Average yield',
  'availability.safety_margin': 'Safety margin',
  'availability.safety_margin_pct': 'Percentage to keep free',
  'availability.suggested_capacity': 'Suggested capacity',
  'availability.close_slot': 'Close slot',
  'availability.suggested_n': 'Suggested capacity: {{n}}',
  'availability.suggested_blocked': 'With this info, it\'s best not to accept new jobs here.',
  'availability.suggested_jobs': 'With the teams and margin chosen, start from {{n}} {{jobs}}.',
  'availability.job': 'job',
  'availability.jobs': 'jobs',
  'availability.apply_to_weekdays': 'Apply this base to standard weekdays',
  'availability.custom_days_unchanged': 'Customized days won\'t change. All others adopt this base.',
  'availability.configure_14': '1. Configure the next 14 days',
  'availability.configure_14_desc': 'Open and adjust only the days you want to change. If a setup is usual, make it the standard rule for that weekday.',
  'availability.follow_standard': '{{n}} days follow the standard base',
  'availability.custom_days': '{{n}} customized day(s)',
  'availability.exception': 'Exception',
  'availability.standard_base': 'Standard base',
  'availability.open_details': 'Open details',
  'availability.close_details': 'Close details',
  'availability.slot_closed': 'Slot closed',
  'availability.jobs_available': '{{n}} jobs available',
  'availability.reopen_slot': 'Reopen slot',
  'availability.slot_no_jobs': 'This slot won\'t receive new jobs. Reopen when you want to sell again.',
  'availability.use_as_weekday_rule': 'Use this setup as the rule for all {{weekday}}s',
  'availability.reset_weekday': 'Reset to {{weekday}} base',
  'availability.weekday_rule_hint': 'If this day is your usual setup, apply the same configuration to all {{weekday}}s.',
  'availability.advanced_mode': 'Advanced mode',
  'availability.advanced_desc': 'Adjust day by day for the next 2 weeks. Use only if you need finer control.',
  'availability.no_jobs_yet': 'No jobs for now',
  'offers.not_signed_in': 'Not signed in',
  'offers.sign_in_to_publish': 'Sign in to publish offers',
  'offers.no_company': 'No company found',
  'offers.complete_onboarding': 'Complete onboarding first',
  'offers.publish_failed': 'Publish failed',
  'offers.published': 'Offer published',
  'offers.live': 'Your seasonal offer is live',
  'offers.title': 'Seasonal offer',
  'offers.description': 'Create a limited-time promotional offer',
  'offers.placeholder.name': 'Offer name (e.g. Spring deep clean)',
  'offers.placeholder.service': 'Select a service',
  'offers.fields.start_date': 'Start date',
  'offers.fields.end_date': 'End date',
  'offers.fields.discount': 'Discount (%)',
  'offers.fields.active': 'Active',
  'offers.publish': 'Publish offer',
  'estimator.title': 'AI price estimator',
  'estimator.description': 'Set smart pricing rules that adapt automatically by service complexity, area and urgency',
  'estimator.tabs.setup_rules': 'Set up rules',
  'estimator.tabs.test_estimator': 'Test estimator',
  'estimator.tabs.ai_insights': 'AI insights',
  'service.templates.basic_cleaning': 'Basic cleaning',
  'service.templates.basic_cleaning_desc': 'Standard per-square-meter cleaning',
  'service.templates.deep_clean': 'Deep clean',
  'service.templates.deep_clean_desc': 'Intensive cleaning with premium materials',
  'service.templates.garden_maintenance': 'Garden maintenance',
  'service.templates.garden_maintenance_desc': 'Regular garden and landscaping maintenance',
  'service.templates.window_cleaning': 'Window cleaning',
  'service.templates.window_cleaning_desc': 'Professional window cleaning',
  'service.templates.carpet_cleaning': 'Carpet cleaning',
  'service.templates.carpet_cleaning_desc': 'Deep carpet cleaning with steam extraction',
  'service.templates.recurring_package': 'Recurring package',
  'service.templates.recurring_package_desc': 'Weekly/monthly recurring service with discount',
  'service.included.dusting': 'Dusting',
  'service.included.vacuuming': 'Vacuuming',
  'service.included.mopping': 'Mopping',
  'service.included.bathroom_cleaning': 'Bathroom cleaning',
  'service.included.kitchen_surfaces': 'Kitchen surfaces',
  'service.benefits.insured_staff': 'Insured, verified staff',
  'service.benefits.eco_products': 'Eco-friendly products',
  'service.benefits.flexible_scheduling': 'Flexible scheduling',
  'service.benefits.satisfaction_guarantee': 'Satisfaction guarantee',
  'service.template_applied': 'Template applied',
  'service.template_applied_desc': 'Template {{name}} was applied to your service.',
  'service.pricing.bounds_invalid_title': 'Invalid price bounds',
  'service.pricing.bounds_invalid': 'MIN cannot be greater than MAX',
  'service.success': 'Success',
  'service.updated': 'Service updated successfully!',
  'service.created': 'Service created successfully!',
  'service.builder.title': 'Dynamic service builder',
  'service.builder.description': 'Create services with flexible pricing options and custom rules',
  'service.tabs.basic_info': 'Basic info',
  'service.tabs.pricing_rules': 'Pricing rules',
  'service.tabs.booking_modes': 'Booking modes',
  'service.tabs.templates': 'Templates',
  'service.tabs.includes_benefits': 'Includes & benefits',
  'service.fields.name': 'Service name',
  'service.placeholders.name': 'e.g. Premium home cleaning',
  'service.fields.category': 'Category',
  'service.placeholders.category': 'Select a category',
  'service.fields.description': 'Description',
  'service.placeholders.description': 'Describe your service in detail...',
  'service.fields.duration': 'Duration (minutes)',
  'service.pricing.modifiers': 'Pricing rules (property size & types)',
  'service.pricing.modifiers_help': 'Let the final price change based on customer choices at booking (sqm, type). If off, price stays fixed.',
  'service.pricing.disabled_explain': 'Pricing rules are off for this service. The customer sees the base price only.',
  'service.pricing.bounds': 'Final price limits (MIN / MAX EUR)',
  'service.pricing.bounds_help': 'Set limits for how much the final price can vary after rules apply.',
  'service.pricing.bounds_min': 'MIN EUR',
  'service.pricing.bounds_min_placeholder': 'e.g. 80',
  'service.pricing.bounds_max': 'MAX EUR',
  'service.pricing.bounds_max_placeholder': 'e.g. 250',
  'service.pricing.sqm': 'Square meters',
  'service.pricing.sqm_unit_hint': 'All values in square meters (m²). Scale is a dimensionless multiplier.',
  'service.pricing.sqm_min': 'Min (m²)',
  'service.pricing.sqm_max': 'Max (m²)',
  'service.pricing.sqm_step': 'Step (m²)',
  'service.pricing.sqm_tiers_help': 'Configure tiers (m² range → % increase).',
  'service.pricing.tiers': 'Tiers',
  'service.pricing.add_tier': 'Add tier',
  'service.pricing.no_tiers': 'No tiers yet — add at least one.',
  'service.pricing.types': 'Types (cleaning only)',
  'service.pricing.custom': 'Custom options',
  'service.pricing.add': 'Add',
  'service.pricing.preview': 'Preview (example 130m², urgent):',
  'service.booking_policy.title': 'Lead time, vendor approval & urgent pricing',
  'service.booking_policy.help': 'The system computes instant / request / urgent from date and time (Europe/Rome). Enable bands and SLAs here.',
  'service.booking_policy.instant': 'Instant (≥ 48h)',
  'service.booking_policy.enabled': 'Enabled',
  'service.booking_policy.min_notice_h': 'Minimum notice (hours)',
  'service.booking_policy.request': 'Vendor request (24–48h)',
  'service.booking_policy.sla_min': 'Vendor response SLA (min)',
  'service.booking_policy.urgent': 'Urgent (12–24h)',
  'service.booking_policy.urgent_explain': 'Short-notice bookings can get an urgent surcharge shown clearly to the customer.',
  'service.booking_policy.max_notice_h': 'Max notice (hours)',
  'service.booking_policy.urgent_mult': 'Urgent price multiplier',
  'service.booking_policy.cutoff_note': 'Same day: bookings only before 08:00 (Europe/Rome), per server policy.',
  'vendor.bulk.loading': 'Loading bulk orders…',
  'vendor.bulk.empty': 'No bulk orders yet.',
  'vendor.bulk.no_rows': 'No rows match these filters.',
  'vendor.tracker.load_error': 'Tracker load error',
  'vendor.tracker.error': 'Error',
  'vendor.tracker.booking_fallback': 'Booking',
  'vendor.tracker.no_data': 'No data yet.',
  'vendor.tracker.no_platform_bookings': 'No Halomora bookings in this period.',
  'vendor.tracker.no_external': 'No external bookings with this label.',
  'vendor.tracker.no_day_bookings': 'No bookings for this day.',
  'vendor.tracker.no_filtered_events': 'No events match the selected filters.',
  'vendor.tracker.no_date': 'No date',
  'vendor.tracker.session_expired': 'Session expired',
  'vendor.tracker.sign_in_again': 'Please sign in again.',
  'vendor.tracker.saved': 'Saved to tracker',
  'vendor.tracker.saved_desc': 'Saved to tracker. It won\'t appear in platform bookings.',
  'vendor.tracker.none': 'None',
  'vendor.tracker.saving': 'Saving…',
  'vendor.tracker.update': 'Update',
  'vendor.tracker.add': 'Add to tracker',
  'vendor.tracker.import_error': 'Import error',
  'vendor.tracker.review_save': '2. Review & save',
  'vendor.recurring.loading': 'Loading recurring bookings…',
  'vendor.recurring.empty': 'No recurring bookings yet.',
  'vendor.recurring.title': 'Recurring bookings',
  'vendor.recurring.desc': 'Manage booking series and occurrences',
  'availability.helper.blocked': 'Slot closed: no new jobs in this time window.',
  'availability.helper.zero': 'Capacity 0: you are not accepting jobs in this slot.',
  'availability.helper.one': 'Capacity 1: you can accept one job well in this slot.',
  'availability.helper.n': 'Capacity {{capacity}}: you can accept {{capacity}} jobs well in this slot.',
  'availability.example_title': 'Simple example',
  'availability.example_line_1': 'Monday morning: 2 teams available, each completes 1 turnover well → capacity 2',
  'availability.example_line_2': 'Monday afternoon: one team busy off-platform, the other has room for 1 job → capacity 1',
  'vendor.bulk.title': 'Bulk orders',
  'vendor.bulk.beta': 'beta',
  'vendor.bulk.desc': 'Each bulk order groups multiple imported bookings. Open to view rows, windows and breakdown.',
  'vendor.bulk.go_calendar': 'Go to calendar',
  'vendor.bulk.scheduler_intro_title': 'AI Turnover Scheduler: signals already available',
  'vendor.bulk.scheduler_intro_desc': 'This panel already collects key scheduler signals: tight windows, unscheduled jobs and expiring batches. The goal is to make it clearer what to confirm, what to bring forward and where more coverage is needed.',
  'vendor.bulk.rows': '{{count}} rows',
  'vendor.bulk.total': 'Total:',
  'vendor.bulk.window': 'Overall window: {{start}} → {{end}}',
  'vendor.bulk.scheduler_signals': 'Scheduler signals: {{summary}}',
  'vendor.bulk.services': 'Services: {{list}}',
  'vendor.bulk.open': 'Open',
  'vendor.bulk.sheet_title': 'Bulk order {{id}}',
  'vendor.bulk.sheet_created': 'Created: {{date}} • Rows: {{count}}',
  'vendor.bulk.filter_status': 'Status filter',
  'vendor.bulk.filter_all': 'All',
  'vendor.bulk.search': 'Search',
  'vendor.bulk.search_ph': 'Address or booking #',
  'vendor.bulk.tight_on': 'Tight windows: ON',
  'vendor.bulk.tight_only': 'Tight windows only',
  'vendor.bulk.tip': 'Tip: to assign times quickly, use “Go to calendar” and reschedule within the window.',
  'vendor.bulk.scheduler_summary': 'Scheduler summary',
  'vendor.bulk.confidence': 'Confidence {{level}}',
  'vendor.bulk.source_server': 'server engine v1',
  'vendor.bulk.source_fallback': 'local fallback (engine unreachable)',
  'vendor.bulk.source_local': 'local calculation',
  'vendor.bulk.updating': 'updating…',
  'vendor.bulk.source_label': 'Source: {{source}}{{extra}}',
  'vendor.bulk.urgent_badge': 'expiring',
  'vendor.bulk.tight_badge': 'window ≤ 2h',
  'vendor.bulk.unscheduled_badge': 'to schedule',
  'vendor.bulk.service_fallback': 'Service',
  'vendor.bulk.price': 'Price:',
  'vendor.bulk.window_row': 'Window:',
  'vendor.bulk.notes': 'Notes:',
  'vendor.bulk.open_booking': 'Open booking',
  'vendor.bulk.assign_time': 'Assign time',
  'availability.slot_closed_short': 'closed',
  'availability.slot_summary': '{{label}}: {{status}}',
  'availability.jobs_count': '{{n}} jobs',
  'availability.job_count': '1 job',
  'availability.suggested_blocked_hint': 'With this info, it\'s best not to accept new jobs here.',
  'availability.suggested_jobs_hint': 'With the teams and margin chosen, you can start from {{n}} {{jobs}}.',
  'availability.apply_weekdays': 'Apply this base to standard weekdays',
  'availability.custom_days_note': 'Customized days won\'t change. All others adopt this base.',
  'availability.configure_14_title': '1. Configure the next 14 days',
  'availability.days_standard': '{{n}} days follow the standard base',
  'availability.days_custom': '{{n}} customized day(s)',
  'availability.slot_closed_label': 'Slot closed',
  'availability.slot_no_jobs_hint': 'This slot won\'t receive new jobs. Reopen when you want to sell again.',
  'availability.use_weekday_rule': 'Use this setup as the rule for all {{weekday}}s',
  'availability.close_slot_hint': 'If you close the slot, Halomora won\'t treat it as available for new jobs.',
  'availability.weekday.0': 'Sunday',
  'availability.weekday.1': 'Monday',
  'availability.weekday.2': 'Tuesday',
  'availability.weekday.3': 'Wednesday',
  'availability.weekday.4': 'Thursday',
  'availability.weekday.5': 'Friday',
  'availability.weekday.6': 'Saturday',
  'availability.load_title': 'Load for the next 14 days',
  'availability.load_desc': 'Jobs already counted (platform + external bookings): {{load}} against total published capacity of {{capacity}}.',
  'availability.over_capacity_days': '{{n}} over-capacity day(s)',
  'availability.closed_with_load': '{{n}} closed day(s) with jobs',
  'availability.near_limit_days': '{{n}} day(s) near limit',
  'availability.load_ok': 'Load under control',
  'availability.load_footer': 'External bookings in the Tracker count here for you only: they are not shown to customers. If you always see red, raise capacity or close days when you don\'t want new bookings.',
  'availability.v2_title': 'Assisted model v2 (coming soon)',
  'availability.v2_badge': 'Next release',
  'availability.v2_desc': 'When the server-side engine is active, you can also add absences, average job duration and buffers for surprises. Suggested capacity will be recalculated automatically based on real load.',
  'vendor.tracker.title': 'Booking tracker',
  'vendor.tracker.desc': 'One place to track platform bookings and off-platform jobs. External bookings stay local to the tracker, don\'t appear in Halomora bookings and don\'t generate commissions.',
  'vendor.tracker.bulk_add': 'Bulk add',
  'vendor.tracker.new_external': 'New external booking',
  'vendor.tracker.kpi.total': 'Total',
  'vendor.tracker.kpi.platform': 'Platform',
  'vendor.tracker.kpi.external': 'External',
  'vendor.tracker.kpi.today': 'Today',
  'vendor.tracker.kpi.next7': 'Next 7 days',
  'vendor.tracker.chart_mix': 'Mix by source',
  'vendor.tracker.chart_services': 'Top services',
  'vendor.tracker.chart_services_desc': 'On Halomora we see catalog services; for external bookings the turnover types you labeled.',
  'vendor.tracker.tab_halomora': 'Halomora',
  'vendor.tracker.tab_external': 'External',
  'vendor.tracker.scheduler_title': 'AI Turnover Scheduler — summary',
  'vendor.tracker.scheduler_desc': 'Based on your real load: Halomora bookings + external bookings you entered here.',
  'vendor.tracker.confidence': 'Confidence {{level}}',
  'vendor.tracker.scheduler_signals': 'Scheduler signals: {{summary}}',
  'vendor.tracker.privacy_note': 'External bookings you add stay private to your profile: they are not shown on the demand side.',
  'vendor.tracker.source_server': 'server engine v1',
  'vendor.tracker.source_fallback': 'local fallback (engine unreachable)',
  'vendor.tracker.source_local': 'local calculation',
  'vendor.tracker.updating': 'updating…',
  'vendor.tracker.source_label': 'Source: {{source}}{{extra}}',
  'vendor.tracker.urgent_title': 'Handle now ({{count}})',
  'vendor.tracker.urgent_desc': 'Rows expiring within 24 hours or still without a date: fix these first.',
  'vendor.tracker.badge_platform': 'Platform',
  'vendor.tracker.badge_external': 'External',
  'vendor.tracker.badge_24h': 'window within 24h',
  'vendor.tracker.badge_flexible': 'flexible, no date',
  'vendor.tracker.external_booking': 'External booking',
  'vendor.tracker.closes': 'closes {{date}}',
  'vendor.tracker.plan': 'Schedule',
  'vendor.tracker.more_rows': '...{{n}} more rows to handle. Open the list to see them all.',
  'vendor.tracker.tight_title': 'Tight windows and busy days',
  'vendor.tracker.tight_desc': 'Cases to plan first: little margin on the useful window, or multiple turnovers on the same day.',
  'vendor.tracker.badge_tight': 'window ≤ 2h',
  'vendor.tracker.cluster_same_day': 'Same-day turnover cluster:',
  'vendor.tracker.cluster_hint': '— plan with extra margin between checkout and check-in.',
  'vendor.tracker.filters': 'Filters:',
  'vendor.tracker.filter_all_sources': 'All sources',
  'vendor.tracker.filter_platform_only': 'Platform only',
  'vendor.tracker.filter_external_only': 'External only',
  'vendor.tracker.filter_all_status': 'All statuses',
  'vendor.tracker.status.planned': 'Planned',
  'vendor.tracker.status.pending': 'Pending (platform)',
  'vendor.tracker.status.confirmed': 'Confirmed (platform)',
  'vendor.tracker.status.in_progress': 'In progress',
  'vendor.tracker.status.completed': 'Completed',
  'vendor.tracker.status.cancelled': 'Cancelled',
  'vendor.tracker.legend_over': 'Over-capacity',
  'vendor.tracker.legend_near': 'Near limit',
  'vendor.tracker.tab_calendar': 'Calendar',
  'vendor.tracker.tab_list': 'List',
  'vendor.tracker.tab_todo': 'To schedule ({{count}})',
  'vendor.tracker.events': '{{count}} events',
  'vendor.tracker.flexible_title': 'No date — Flexible ({{count}})',
  'vendor.tracker.flexible_desc': 'External bookings with no date: the customer asked you to schedule the cleaning. Edit when you have chosen the window or time.',
  'vendor.tracker.mode_flexible': 'Flexible',
  'vendor.tracker.delete_confirm': 'Delete this booking from the tracker?',
  'vendor.tracker.deleted': 'Deleted',
  'vendor.tracker.deleted_desc': 'Booking removed from tracker.',
  'vendor.tracker.delete_failed': 'Could not delete.',
  'vendor.tracker.retry': 'Try again.',
  'vendor.tracker.other': 'Other',
  'vendor.tracker.no_label': 'No label',
  'vendor.tracker.unit_booking': 'booking',
  'vendor.tracker.mode.exact': 'Exact time',
  'vendor.tracker.mode.window': 'Checkout/check-in window',
  'vendor.tracker.mode.date_only': 'Date only',
  'vendor.tracker.mode.flexible': 'Flexible',
  'vendor.tracker.time.all_day': 'All day',
  'vendor.tracker.edit': 'Edit',
  'vendor.tracker.delete': 'Delete',
  'vendor.tracker.range_title': 'With range — Pin exact day ({{count}})',
  'vendor.tracker.range_desc': 'Bookings with a declared range — checkout/check-in window or date only. When you pick the exact day and time, open the row with Schedule and switch to exact time mode.',
  'vendor.tracker.range_label': 'Range',
  'vendor.tracker.flexible_pending': 'Flexible (to schedule)',
  'vendor.tracker.detail.service': 'Service',
  'vendor.tracker.detail.customer': 'Customer',
  'vendor.tracker.detail.phone': 'Phone',
  'vendor.tracker.detail.email': 'Email',
  'vendor.tracker.detail.address': 'Address',
  'vendor.tracker.detail.date': 'Date',
  'vendor.tracker.detail.time': 'Time',
  'vendor.tracker.detail.amount': 'Amount',
  'vendor.tracker.detail.number': 'Number',
  'vendor.tracker.detail.notes': 'Notes',
  'vendor.tracker.detail.label': 'Label',
  'vendor.tracker.detail.when': 'When',
  'vendor.tracker.detail.duration': 'Duration',
  'vendor.tracker.detail.guests': 'Guests',
  'vendor.tracker.detail.pets': 'Pets',
  'vendor.tracker.detail.kids': 'Children',
  'vendor.tracker.detail.yes': 'Yes',
  'availability.day_load_empty': 'Current load: 0 jobs. Publish capacity to show how many you can accept.',
  'availability.load_ok_label': 'Load OK',
  'availability.load_closed_day': 'Jobs on closed day',
  'availability.load_near_limit': 'Near limit',
  'availability.load_compact': '{{load}} load · {{status}}',
  'availability.load_compact_closed': 'closed',
  'availability.load_compact_cap': 'cap {{capacity}}',
  'availability.load_current': 'Current load: {{load}}',
  'availability.slot_declared_closed': 'slot declared closed',
  'availability.published_capacity': 'published capacity: {{capacity}}',
  'availability.v2_absences': 'Expected absences',
  'availability.v2_absences_ph': 'e.g. vacation, sick leave',
  'availability.v2_absences_hint': 'Reduces capacity for affected days.',
  'availability.v2_duration': 'Average job duration (min)',
  'availability.v2_duration_ph': 'e.g. 90',
  'availability.v2_duration_hint': 'Helps estimate how many jobs fit in a slot.',
  'availability.v2_buffer': 'Buffer for surprises',
  'availability.v2_buffer_ph': 'e.g. 15 min between jobs',
  'availability.v2_buffer_hint': 'Margin between one turnover and the next.',
  'scheduler.counts_summary': '{{tight}} tight windows • {{unscheduled}} unscheduled • {{urgent}} expiring',
  'scheduler.risk.count': '{{count}} × {{label}}',
  'scheduler.risk.URGENT': 'expiring within 24h',
  'scheduler.risk.TIGHT_WINDOW': 'window ≤ 2h',
  'scheduler.risk.UNSCHEDULED': 'still no date or time',
  'scheduler.risk.SAME_DAY_TURNOVER': 'checkout and check-in same day',
  'scheduler.risk.OVER_CAPACITY_DAY': 'over-capacity day',
  'scheduler.risk.NEAR_CAPACITY_DAY': 'day near saturation',
  'scheduler.risk.CLOSED_DAY_WITH_LOAD': 'day marked closed but with jobs',
  'scheduler.risk.SAME_DAY_TURNOVER_CLUSTER': 'same-day turnover cluster',
  'scheduler.action.closed_with_load': 'You have jobs on days marked closed. Update availability or move jobs.',
  'scheduler.action.over_capacity': 'One or more days are over capacity. Shift load, raise published capacity, or stop accepting more.',
  'scheduler.action.urgent': 'Confirm expiring rows immediately or expand coverage.',
  'scheduler.action.tight_unscheduled': 'Prioritize tight-window turnovers and schedule from the calendar.',
  'scheduler.action.unscheduled': 'Schedule unassigned rows before accepting new load.',
  'scheduler.action.ok': 'Batch under control: monitor and update the calendar only if things change.',
  'scheduler.batch.closed': 'Note: on {{count}} useful {{dates}} closed slots or no published capacity. Update availability first if you want to cover these turnovers.',
  'scheduler.batch.closed_dates_one': 'date',
  'scheduler.batch.closed_dates_many': 'dates',
  'scheduler.batch.low_capacity': 'Low published capacity on {{count}} {{dates}} touched by this batch. If your real team has more margin, update Availability before scheduling.',
  'scheduler.batch.low_dates_one': 'date',
  'scheduler.batch.low_dates_many': 'dates',
  'scheduler.confidence.alta': 'High confidence: the scheduler has enough data for this suggestion.',
  'scheduler.confidence.media': 'Medium confidence: some rows lack time or published capacity.',
  'scheduler.confidence.bassa': 'Low confidence: too much missing data — complete scheduling and availability.',
  'scheduler.confidence_level.alta': 'high',
  'scheduler.confidence_level.media': 'medium',
  'scheduler.confidence_level.bassa': 'low',
  'scheduler.banner.over_capacity': '{{count}} {{days}} over published capacity. Open the calendar to redistribute or update capacity.',
  'scheduler.banner.closed_with_load': 'You have jobs on {{count}} closed {{days}}. Reopen the slot or move jobs.',
  'scheduler.banner.same_day_cluster': '{{count}} {{days}} with same-day turnover clusters: plan with wide margins between checkout and check-in.',
  'scheduler.banner.near_capacity': '{{count}} {{days}} near saturation: consider whether to accept more load.',
  'scheduler.banner.day_one': 'day',
  'scheduler.banner.day_many': 'days',
  'scheduler.banner.date_one': 'day',
  'scheduler.banner.date_many': 'days',
};
export default en;
